import Realtime from './lib/realtime/realtime';
import EventEmitter from './lib/helpers/EventEmmiter';
import TranslateService from './lib/service/e3.viewer.translate.service';
import ModalService from './lib/service/modal/e3.viewer.modal.service';
import HelpService from './lib/service/help.service';
import {changeTitle} from './lib/service/title.service';
import BottomControls from './pannellum-controls/pannellum-controls-player';
import AgentCall from './lib/agent.call/agent.call';
import PlayerService from './lib/service/e3.viewer.player.service';
import MediaCoordinator from './lib/service/media-coordinator';
import Pannellum from './lib/pannellum';
import MakeFloorplanScreenshots from './lib/service/makeFloorplanScreenshots';
import {OrientationHelper} from './lib/orientation.helper'
import Deffer from 'lib/helpers/deffer';
import ProtobufCommonService from 'a_common-folder/services/protobuf.service';
import E3Plan3D from './lib/e3plan-3d/e3plan-3d';
import E3Plan2D from './lib/e3plan-2d/e3plan-2d';
import Narration from './lib/narration/';
import { resolveNarrationLang } from './lib/narration/lang-map';
import Avatar from './lib/avatar/';
import VisitTracker from './lib/visitTracker';
import UI from 'lib/ui';
import RenderZoneRenderer from './lib/video-zone/renderer';
import {delay, getPathId, loadJsFile, updateInfoIconStyle} from 'lib/helpers/common';
import {isFBApp, isMiuiBrowser} from './lib/realtime/modules/helper';
import {setGeoIpURL} from 'a_common-folder/services/geo.service';
import E3CheckPassword from './lib/e3-check-password/e3-check-password';
import {cameraAccessTemplate} from 'a_root-folder/lib/service/modal/templates/cameraAccess';
import {CDN_URL_SHARE_MIN_JS, PREVIEW_SIZE} from 'a_root-folder/constants';
import E3BackgroundAudio  from 'lib/e3-background-audio/index';
import E3Measurement  from 'lib/measurement/index';
import E3Sidebar  from 'lib/e3-sidebar/index';
import E3LanguageSelector from './lib/e3-language';

import {MEASUREMENT, RESOLUTION, AUTOROTATE} from 'a_common-folder/constants';
import Loading from 'lib/loading';
import {addVideoBubble} from "./lib/service/html.service";
import Thumbnails from 'a_root-folder/lib/thumbnails';
import {getScreenShareStream, canShareScreen, getUserMedia } from 'a_root-folder/lib/service/webrtc.service';
import LeadGeneration from "lib/lead-generation";
import getCookie from 'lib/cookie/getCookie';
import {configData} from "service/config.data";
import GoogleMapPreview from "lib/e3-google-map-iframe";
import E3Listener from "lib/e3-listener";
import Accessibility from "lib/accessibility";
import {initRemoteJS} from "service/remoteJS";
import preventPinch from './lib/helpers/preventPinch';
import ConvertToVideo from './lib/service/video.service';
import controlsKeycodes from './lib/helpers/controls-keynumbers';
import Timeout from './lib/helpers/timeout';
import 'a_root-container/common_modules/spriteGenerator/dist/app.bundle';
import initInfoSwiper from './lib/swiper';
import Model3dButton from './lib/convert3d/public';

require('./lib/pannellum.css');
require('./styles/main.scss');
require('./styles/poi-info.scss');
require('./styles/flags.scss');
require('./lib/libpannellum');
require('./lib/helpers/RequestAnimationFrame');
require('./lib/pannellum');
require('./lib/helpers/draggable');
require('./lib/helpers/swipable');
require('./utils/swiper/swiper-bundle.min.css');

const detectBrowser = require('a_common-folder/utils/detectBrowser');
const md5_hex = require('js-md5');

var NoSleep = require('a_common-folder/utils/no-sleep');

var cloneDeep = require('lodash/cloneDeep');
var DetectRTC = require('detectrtc');
var Promise = require('promise');

var DOMReady = function (a) {
    var b = document;
    if (b.readyState === 'complete') {
        return a();
    }
    var c = 'addEventListener';
    b[c] ? b[c]('DOMContentLoaded', a) : window.attachEvent('onload', a)
};

function copy(obj) {
    var res = {};
    for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
            res[i] = obj[i];
        }
    }
    return res;
}

if (!(/(\.eyespy360\.com|\.vr-360-tour\.com)$/.test(window.location.hostname))) throw new Error('not valid host');

export default class Viewer extends EventEmitter {
    _Pannellum = Pannellum;
    _BottomControls = BottomControls;
    _protobufService = new ProtobufCommonService('e3.Play');
    _noSleep = new NoSleep();
    _infoModalHidden = false;
    _poiAnimationClassList = ['e3-poi-right', 'e3-poi-left', 'e3-poi-top', 'e3-poi-bottom'];
    _poiAsyncAction = null;
    _isNeedUpdate3dTexture = false;

    constructor() {
        super();
        this.config = {};
        this.pannellumJson = {};
        this.viewer = {};
        this.vrView = null;
        this.funcs = {};
        this._styles = {};
        this._companyLogo = null;
        this._sceneChanging = {};
        this.vrViewCurrentScene = null;
        this.vrViewCurrentPosition = null;
        this.vrViewCurrentPosition = null;
        this.hotspot_url = null;
        this._player = null;
        this._e3liveRoomId = null;
        this._isSupportRTC = DetectRTC.isWebRTCSupported;
        this._browser = DetectRTC.browser;
        this._getOsName = DetectRTC.osName;
        this.isWebsiteHasWebcamPermissions = DetectRTC.isWebsiteHasWebcamPermissions;
        this.isWebsiteHasMicrophonePermissions = DetectRTC.isWebsiteHasMicrophonePermissions;
        this._detectRTC = DetectRTC;
        this._mp4File = null;
        this._isTouchDevice = 'ontouchstart' in document.documentElement;
        this._orientationEnabled = false;
        this._vrReady = false;
        this._screenShotStream = null;

        this._fullscreenEnabled = (
            ('fullscreen' in document || 'mozFullScreen' in document || 'webkitIsFullScreen' in document || 'msFullscreenElement' in document) &&
            navigator.userAgent.indexOf(' UCBrowser/') == -1) && !((navigator.userAgent.indexOf('Mozilla/5.0') > -1 && navigator.userAgent.indexOf('Android ') > -1 && navigator.userAgent.indexOf('AppleWebKit') > -1) && (navigator.userAgent.indexOf('Version') > -1)) &&
            (document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);

        if (navigator.userAgent.indexOf(' UCBrowser/') > -1) {
            document.body.classList.add('uc-browser');
        }

        if (navigator.userAgent.indexOf(' Edge\/') > -1) {
            document.body.classList.add('edge-browser');
        }

        this._stylesShevron = null;
    }

    init(element, config) {
        this._helperService = new HelpService();
        this._location = this._helperService.location;
        this._translateService = new TranslateService();
        this._modalService = new ModalService(element, this._translateService, config);
        this._mediaService = new MediaCoordinator();
        configData.config = config;
        this.E3CheckPassword = new E3CheckPassword();
        this._urlParams = this._helperService.urlParams;

        // Report this view to the AI widget backend when the visitor is
        // identifiable (esv token from a tracked link, or the phone cookie) —
        // lets the AI recall "you viewed this tour yesterday" on any channel.
        this._visitTracker = new VisitTracker(this._urlParams);
        this._visitTracker.start();

        if (!config.editable && config.password_hash &&
            // !this._helperService.inIframe() &&
            // !(/(\.eyespy360\.com)$/.test(document.referrer)) &&
            !this.E3CheckPassword.check(config.password_hash, '') &&
            !this.E3CheckPassword.check(config.password_hash, this._getCookie('authorize')) &&
            !this._urlParams.converte3video
        ) {
            this._modalService.showCreatedModal('check-password-modal', this._modalService.checkPassword(config.scenes[0].thumbnail, (e) => {
                e.preventDefault();

                const checkingPassword = document.querySelector('.check-password-input').value;
                if (this.E3CheckPassword.check(config.password_hash, checkingPassword)) {
                    this._modalService.close('check-password-modal');
                    this.run(element, config);
                    this._setCookie('authorize', checkingPassword);
                } else {
                    const checkingPasswordLabel = document.querySelector('.check-password-label');
                    checkingPasswordLabel.innerText = 'Error. incorrect password';
                    checkingPasswordLabel.style.marginBottom = '10px';
                }
            }), true);
        } else {
            try{
                this.run(element, config);
            }catch (e) {
                console.error(e);
            }
        }
    }

    _createGooglemapIframe(){
        const preview = document.createElement('div');
        preview.classList.add('e3-googlemap-iframe__preview');

        const previewContainer = document.createElement('div');
        previewContainer.classList.add('e3-googlemap-iframe__preview__container');
        preview.appendChild(previewContainer);

        this.container.appendChild(preview);

        let e3PreviewContainer = this.container.querySelector('.e3-googlemap-iframe__preview');
        let iframeContainer = e3PreviewContainer.querySelector('.e3-googlemap-iframe__preview__container');
        const planPreview = new GoogleMapPreview(iframeContainer, this._editable, {
            type: '2d',
            metrical: this.metrical,
            address: this.config.title.replace(/\s/g, '+')
        });

        planPreview.on('update', (plan) => {

        });
    }

    run(element, config) {
        DOMReady(function () {
            var detectMouse = function (e) {
                if (e.type === 'mousedown') {
                    window.e3touchDevice = false;
                } else if (e.type === 'touchstart') {
                    window.e3touchDevice = true;
                    element.classList.add('nohover');
                }
                // remove event bindings, so it only runs once
                document.body.removeEventListener('mousedown', detectMouse);
                document.body.removeEventListener('touchstart', detectMouse);
                (window.e3touchDeviceCallback || function () {
                })(window.e3touchDevice);
            };
// attach both events to body
            document.body.addEventListener('mousedown', detectMouse);
            document.body.addEventListener('touchstart', detectMouse);
        });
        preventPinch.init(element);
        setGeoIpURL(config.geoip_url);
        this._isAndroid = detectBrowser.isAndroid;
        this._is_iOS = detectBrowser.is_iOS;
        this._isWebView = detectBrowser.isWebView;
        this._isIosWebView = detectBrowser.isIosWebView;
        this._isFBapp = detectBrowser.isFBapp;
        this._isOperaMini = detectBrowser.isOperaMini;
        this._isIosChrome = detectBrowser.isIosChrome;
        this._is_Safari = detectBrowser.is_Safari;
        this._isOculusBrowser = detectBrowser.isOculusBrowser;
        this._isIosMotionDisabled = true;
        this._countSceneChange = 0;

        this.metrical = true;

        this._e3Timeout = new Timeout();
        this.config = config;
        this._language = (config.lang || navigator.language || navigator.userLanguage) || 'gb';
        this._country = config.lang || navigator.language || 'GB';
        this._countryCode = this._setCountryCode(this._country);
        this._translationPromise = this._translateService.getTranslation(this._language);
        this._e3liveRoomId = this._urlParams.room;
        this._disableE3live = this._urlParams.hidelive;
        this._autoE3play = this._urlParams.autoe3play;
        this._autoE3plan = this._urlParams.autoe3plan;
        this._autoE2plan = this._urlParams.autofloorplan;
        this._showLogs = this._urlParams.showLogs;
        this._intro_mouse_icon = !this._urlParams.intro_mouse_icon;
        this._nomini3donmobile = this._urlParams.nomini3donmobile;
        this._hideLeadGeneration = this._urlParams['lead_gen']  === 'true' ? false  : true;
        this.allow_live_incoming_calls = config.priceplan.allow_live_incoming_calls;
        this.e3live_idle = config.priceplan.e3live_idle;
        this.priceplan = config.priceplan;
        this.priceplanPro = config.priceplan.allow_live_incoming_calls == 1 ? true : false;
        this._startTime = new Date().getTime();
        this._accessibility = this._urlParams['accessibility'] === 'false' ? false : true;

        // if(!this._showLogs) this._initConsoleWrapper();

        this.getPermissions();
        this.checkNoBrandingPermissions();
        this.runDebuggers();

        if (this._urlParams.hide_nadir && ((config.priceplan.allow_tour_nadir_hide === '1') || (config.priceplan.allow_tour_nadir_hide === 'true'))) {
            config.nadir_url = '';
        }

        this.container = this._initContainer(element);
        this.loading = new Loading(this.container, 'loading');

        this.show_thumbnails = Number(this.config.show_thumbnails);
        this.agentID = Number(this.config.agent.agentID);
        // this.container = element;
        // this.container.classList.add('e3-viewer-container');
        this.pannellumContainer = document.createElement('div');
        this.pannellumContainer.classList.add('e3-viewer-pannellum-wrapper');
        this.container.appendChild(this.pannellumContainer);
        this.panorama = document.createElement('div');
        this.panorama.classList.add('e3-viewer-pannellum');
        this.pannellumContainer.appendChild(this.panorama);
        this._initVrview();
        this._initE3PlanPreview()
        this.e3plan_json = typeof config.e3plan_json === 'object' ? config.e3plan_json : config.e3plan_json ? JSON.parse(config.e3plan_json) : null;
        // "3D model" button when a model was built for this floor plan (lib/convert3d, prototype)
        if (!config.editable) Model3dButton.init({ plan: this.e3plan_json, getPanel: () => this._panel, container: this.container })
            .then(b => { this._model3dButton = b; });
        this.narration_json = typeof config.narration_json === 'object' ? config.narration_json : config.narration_json ? JSON.parse(config.narration_json) : null;
        this._countryCode = this._setCountryCode(this._country);

        if (this._urlParams.hidehotspotlabels) {
            this.panorama.classList.add('hidehotspotlabels');
        }

        if (!(this._urlParams.hide_logo && ((config.priceplan.allow_tour_logo_hide === '1') || (config.priceplan.allow_tour_logo_hide === 'true')))) {
            this._companyLogo = this._createCompanyLogo(config.company_logo, config.company_url);
        }

        // this._prepareConfig();
        this._initListener();
        this.convertToPannellum(this.config, (this._urlParams['initvars.autorotate.enabled'] && !this._urlParams['autoe3play']) ? this._urlParams['initvars.autorotate.enabled'] : false);
        this.initPannellum(this.pannellumJson);
        if (!!this.config.e3play_json) {
            const e3play_json = JSON.parse(this.config.e3play_json);
            if(e3play_json.background && !config.editable && !this._urlParams.hide_background_audio && !this._urlParams.converte3video) {
                const e3BackgroundAudio = new E3BackgroundAudio(e3play_json.background, this._translateService.translate.bind(this._translateService), this._modalService);
                // Ambient loop: paused while any tour media plays, resumed when idle.
                // Not resumed during e3play (its 'play' would exit the player).
                this._mediaService.register('background', {
                    layer: 'background',
                    pause: () => e3BackgroundAudio.pause(),
                    resume: () => !this._player && e3BackgroundAudio.playAudio(),
                });
                this._mediaService.bindElement(e3BackgroundAudio.element, 'background');

                let backgroundControlsReady = false;
                e3BackgroundAudio.on('play', () => {
                    if (this._player) this._onE3PlayExit();

                    // 'play' fires again on every resume — wire the controls once.
                    if (backgroundControlsReady) return;
                    backgroundControlsReady = true;

                    this._panel.addMuteBackgroundButton();

                    this._panel.on('volume--mute', () => {
                        e3BackgroundAudio.mute(true);
                        this._panel.removeMuteBackgroundButton();
                        this._panel.addPlayBackgroundButton();
                    });
                    this._panel.on('volume--play', () => {
                        e3BackgroundAudio.mute(false);
                        this._panel.removePlayBackgroundButton();
                        this._panel.addMuteBackgroundButton();
                    });
                    this.on('on-e3-play-start', () => {
                        e3BackgroundAudio.mute(true);
                    })
                    this._panel.on('e3-player.exit', () => {
                        // e3BackgroundAudio.mute(false);
                    });
                });

                this._e3BackgroundAudio = e3BackgroundAudio;
            }
            // if(e3play_json.audio){
                this.config.e3play = !this.permissions['hide_e3play'] && this.config.e3play_json.match(/commands/) ? JSON.parse(this.config.e3play_json) : false;
                delete this.config.e3play_json;
            // }
        }
        this.frontendCompanyID = `frontend_config_${this.config.agent.companyID}`;

        this.initPanel(config, this._translateService);

        this.local_stream = null;
        this._resolution = RESOLUTION;
        if (this._urlParams.hidetitle) {
            this._panel.addClass('hidetitle');
        }

        if (this._urlParams.hideinfo === 'all' || this._urlParams.hideinfo === 'labels') {
            this.panorama.classList.add('hideinfo');
        }

        if (this._urlParams.hideinfo === 'all' || this._urlParams.hideinfo === 'page') {
            this._panel.addClass('hideinfo');
        }

        if (!config.editable && !!this.config.e3play && !!this._disableE3live && !this._autoE3play && !this.priceplanPro) {
            this._translationPromise.then(function () {
                this._agentCall = new AgentCall(this._translateService, this.viewer.getScene());
                this._agentCall._modalService = this._modalService;
                var textTitle = this.priceplanPro ? 'AVAILIABLE_FOR_LIVEVIEWING' : 'AVAILIABLE_FOR_E3PLAY';
                var textButton = this.priceplanPro ? 'START_E3_PLAY' : 'START_E3_PLAY';
                this._agentCall.showPlayE3PLay(this._onE3PlayStart.bind(this), textTitle, textButton);
            }.bind(this));
        }

        if (!config.editable && (this.allow_live_incoming_calls > 0 || this._e3liveRoomId)) {
            loadJsFile('//cdn.ably.io/lib/ably.min-1.js').then(async () => {
                Realtime.prototype.allow_live_incoming_calls = this.allow_live_incoming_calls;
                Realtime.prototype.config = this.config;
                Realtime.prototype._sendAnalitics = this._sendAnalitics;
                Realtime.prototype.viewer = this.viewer;
                Realtime.prototype._showInfo = this._showInfo;
                Realtime.prototype._hideInfoModal = this._hideInfoModal;
                Realtime.prototype._e3context = this;
                Realtime.prototype._setCookie = this._setCookie;
                Realtime.prototype.parse_url = this.parse_url;
                Realtime.prototype._startTime = this._startTime;
                Realtime.prototype._modalService = this._modalService;
                Realtime.prototype._helperService = this._helperService;
                await this._translationPromise;

                if (this._e3liveRoomId) {
                    await loadJsFile('https://www.eyespy360.com/library/adapter.min.js')
                    this._realtime = new Realtime(this._translateService, this.e3live_idle);
                    this.addRealtimeListener();
                    const res = await this._loadDetectRTC();
                    Realtime.prototype._local_stream = this._local_stream;
                    Realtime.prototype._browser = this._browser;
                    if (res === 'success') {
                        Realtime.prototype.isWebsiteHasWebcamPermissions = true;
                        Realtime.prototype.isWebsiteHasMicrophonePermissions = true;
                        Realtime.prototype.hasWebcam = true;
                        Realtime.prototype._isSupportRTC = true;
                    } else {
                        Realtime.prototype.isWebsiteHasWebcamPermissions = this._detectRTC.isWebsiteHasWebcamPermissions;
                        Realtime.prototype.isWebsiteHasMicrophonePermissions = this._detectRTC.isWebsiteHasMicrophonePermissions;
                        Realtime.prototype.hasWebcam = this._detectRTC.hasWebcam;
                        Realtime.prototype._isSupportRTC = this._isSupportRTC;
                    }

                    document.getElementById('e3-viewer').classList.add('e3-live');
                    this._panel._addE3Live();

                    this._realtime.init(
                        document.getElementById('e3live'),
                        this._e3liveRoomId,
                        config,
                        {tokbox: this.permissions['tokbox']});
                } else if (this.priceplanPro) {
                    this._agentCall = new AgentCall(this._translateService, this.viewer.getScene());
                    this._agentCall._modalService = this._modalService;
                    if (!this._urlParams.converte3video) {
                        this._agentCall._initCompanyRoom(!!this._disableE3live,
                            this._onE3PlayStart.bind(this))
                    }
                }
               
            })
            .catch((e) => {
                console.error(e);
            });
        }

        this.initControls();
        this._updateChangeSceneButtons();
        this._fixViewportHeight();
        if (this._urlParams.autoe3play && !this._urlParams.room && !this._urlParams.converte3video) {
            this._onE3PlayStart();
        }
        if (this._urlParams.converte3video && window.parent) {
            this._startConvertVideo();
        }
        if ((this._initialMode = this._urlParams['initialmode']) === 'vr') {
            var gestureTarget = document.createElement('div');
            gestureTarget.classList.add('gesture-target');
            document.body.appendChild(gestureTarget);
            gestureTarget.onclick = function () {
                document.body.removeChild(gestureTarget);
                this.vr();
            }.bind(this);

            var text = document.createElement('span');
            gestureTarget.appendChild(text);
            this._translationPromise.then(function () {
                var txt;
                try {
                    txt = this._translateService.translate('REQUEST_GESTURE_VR');
                } catch (e) {
                    txt = 'Tap to open VR';
                }
                text.innerText = txt;
            }.bind(this));
        }

        // this.onBeforeUnloadListener();

        // ... init orientation helper
        if (
            !config.editable &&
            !this._e3liveRoomId &&
            !this._autoE3play &&
            !this._autoE3plan &&
            !this._autoE2plan &&
            !this._urlParams.converte3video &&
            this._intro_mouse_icon
        ) this._initOrientationHelper();

        if(!config.editable && !this._e3liveRoomId && this.narration_json){
            this.initNarration(config);
        }
        // Only tours with an avatar configured (a TypeError was thrown on every other tour)
        if (Avatar.isConfigured(config.avatar_json)) {
            this.initAvatar();
        }
        this._initRenderZones();
    }

    _setCountryCode(language) {
        let countryCode = getCookie('language-code');
        if (!countryCode) {
            countryCode = language.match(/\-/) ? language.split('-')[1].toLowerCase() :  language;
        }

        const allCodes = this._findAllLang();

        if (allCodes.length) {
            const available = allCodes.map(c => c.toLowerCase());
            countryCode = resolveNarrationLang(countryCode.toLowerCase(), available);
        }

        return countryCode.toUpperCase();
    }

    _initListener() {
        this._listener = new E3Listener();
        this._listener.on('accessibility', (e) => {
            if(!this._accessibility) return ;
            
            if(this.accessibility) {
                return this.accessibility.toogleModal(e);
            }

            this.initAccessibility();
        })
    }

    initNarration(config) {
        let lang = this._countryCode;

        const narration = new Narration(this.container, {
            lang,
            translateService: this._translateService,
            modalService: this._modalService,
            mediaService: this._mediaService,
            json: this.narration_json
        });
        this._narration = narration;
        const sceneID = this.viewer.getScene();
        narration.init(sceneID);
        let onMouseMove = false;

        const onSceneChange = (sceneID) => {
            narration.init(sceneID, this._countryCode);
            narration.onUserMoveMent();
        }

        this.on('scene-select-start', onSceneChange);
        this.viewer.on('on-start-hotspottab', onSceneChange);
        this.on('on-e3plan3d-scene.change.start', onSceneChange);

        this.on('on-change-language', () => {
            narration.updateLang(this._countryCode);
        });

        this.viewer.once('on-document-mouse-down', () => {
            if(onMouseMove) return ;
            narration.onUserMoveMent();
            onMouseMove = true;
        })
        this.viewer.once('on-document-touch-start', () => {
            if(onMouseMove) return ;
            narration.onUserMoveMent();
            onMouseMove = true;
        });
        this.on('on-e3-play-start', () => {
            narration.hide();
        });
        this.on('on-e3-play-exit', () => {
            narration.show();
        });

        this.viewer.on('open.info',() => {
            narration.pause();
        });

        this.on('close.info',() => {
            if (this._infoModalOpened()) return ;

            narration.playBack();
        });

        this.on('open.fullscreen.info',() => {
            narration.pause();
        });

        this.on('info-more-open', () => {
            narration.pause();
        })

        this.on('info-close-handler', () => {
            
            narration.playBack();
        })

        this.on('close.fullscreen.info',() => {
            if (this._infoModalOpened()) return ;

            narration.playBack();
        });

        this._panel.on('floorplans_2d.init', () => {
            narration.pause();
        })

        this._panel.on('floorplans_3d', () => {
            narration.pause();
        })

        narration.on('on-user-rescrition', () => {
            if (!this._orientationHelper) return this._initOrientationHelper();
            console.log('on-user-rescrition')
        })
    }

    _getHostpotArray(sceneID) {
        return this.config.scenes.find((obj) => obj.id == sceneID)?.hotspots || [];
    }

     async initAvatar() {
        let lang = this._countryCode;
        let config = cloneDeep(this.config);

        if (config.avatar_json && /^https?:\/\//.test(config.avatar_json.trim())) {
            try {
                const res = await fetch(config.avatar_json.trim(), { cache: 'no-store' });
                config.avatar_json = JSON.stringify(await res.json());
            } catch(e) {
                console.warn('Failed to load avatar_json from URL:', e);
                config.avatar_json = null;
            }
        }

        if (!Avatar.isConfigured(config.avatar_json)) return false;
        // No microphone check here: without one the button still shows, and
        // pressing Play explains that a microphone is needed (Avatar._acquireMic).

        const avatar = new Avatar(this.container, {
            lang,
            translateService: this._translateService,
            modalService: this._modalService,
            config,
            editable: this._editable
        });
        this._avatar = avatar;
        avatar.createPanel();
        const sceneID = this.viewer.getScene();
        avatar.init(sceneID);

        const onSceneChange = async (sceneID, position) => {
            // No guide running: the viewer handles the visitor's click itself —
            // just remember the room (loading it again here doubled every move)
            if (!avatar.guide) {
                avatar.setSceneId(sceneID);
                return false;
            }
            const { pitch, yaw } = position || {};

            // In museum mode loadScene wraps _loadScene in a zoom animation, so
            // 'scenechange' fires asynchronously — after the canvas snapshot loads.
            // Register the listener BEFORE calling loadScene so we never miss it,
            // then wait for the correct scene's 'scenechange' (which is when render
            // zones for the new scene are populated).
            const scenePromise = new Promise(resolve => {
                if (String(this.viewer.getScene()) === String(sceneID)) {
                    resolve(); return;
                }
                const onSC = (id) => {
                    if (String(id) === String(sceneID)) {
                        this.viewer.off('scenechange', onSC);
                        resolve();
                    }
                };
                this.viewer.on('scenechange', onSC);
            });

            // If viewer is still loading (previous animation in progress), wait
            // for it to complete so loadScene is not silently dropped.
            if (!this.viewer.isLoaded()) {
                await new Promise(r => this.viewer.once('load', r));
            }
            this.viewer.loadScene(sceneID, pitch, yaw);
            await scenePromise;

            const isNeedSpeak = await avatar.isNeedSpeak(sceneID);
            avatar.setSceneId(sceneID);
            if (avatar.guide) avatar.guide._fireEvent('scene:ready', sceneID);
            // room intro, or the question the visitor asked together with the move
            avatar.onArrive(isNeedSpeak);
        }

        const onChangeMode = async (mode) => {
            switch(mode) {
                case '3d':
                    this._on3DPlanClick({view3D: true});
                    break;
                case '2d':
                    this._panel.init2DFloorplan();
                    break;
                case 'close':
                    avatar.pause();
                break;
                default:
                    
            }
        }

        const waitForLoad = () => {
            console.log('wait for load scene');
            return new Promise(resolve => {
                this.viewer.once("load", resolve);
            });
        }

        // Media the visitor starts (render zone, info-label audio/video, narration)
        // pauses the avatar the same way it pauses narration: the AI stops
        // mid-sentence and the museum guide pauses in place, resuming once that
        // media stops. Zones / info labels the guide opens itself are part of its
        // script (it waits for them), so they don't count.
        let guideMedia = 0; // > 0 while a guide-requested zone / info label is open
        const onMediaChange = (activeId) => {
            if (!avatar.guide) return;
            if (!activeId) avatar.guide.holdForMedia(false);
            else if (guideMedia === 0) avatar.guide.holdForMedia(true);
        };
        if (this._mediaService) this._mediaService.on('change', onMediaChange);

        const onOpenInfo = async ({sceneID, hotspotID, skipNavigation = false, waitForClose = false}) => {
            if (!skipNavigation) {
                const loadPromise = waitForLoad();
                await this.viewer.loadScene(sceneID);
                await loadPromise;
            }

            const hotspots = this._getHostpotArray(sceneID);
            if (!hotspots.length) return;

            const hotspot = hotspots.find(obj => obj.id === hotspotID || obj.poiID === hotspotID);
            if (!hotspot) return;

            const div = document.body.querySelector(`.info-${hotspot.poiID}`);

            if (waitForClose) {
                this._pendingInfoResolve = null;
                const donePromise = new Promise(r => { this._pendingInfoResolve = r; });
                guideMedia++;
                this._showInfo(hotspot.poiID, hotspot.htmlURL, hotspot.title, hotspot.type, div, {}, "balloon");
                try { await donePromise; } finally { guideMedia = Math.max(0, guideMedia - 1); }
                if (avatar.guide) avatar.guide._fireEvent('info:done');
            } else {
                this._showInfo(hotspot.poiID, hotspot.htmlURL, hotspot.title, hotspot.type, div, {}, "balloon");
            }

            avatar.setSceneId(sceneID);
        }

        avatar.on('on-change-scene', onSceneChange.bind(this));
        this.on('scene-select-start', onSceneChange);
        avatar.on('on-close-mode', onChangeMode.bind(this));
        avatar.on('on-open-info', onOpenInfo.bind(this));
        avatar.on('close-hotspot', () => {
            if (this._infoModal?.closeHandler) this._infoModal.closeHandler();
        });
        let currentSkip = null;
        avatar.on('play-render-zone', ({ render_zone_id }) => {
            if (!this.renderZone) return;
            let skipBtn = null;
            const removeSkip = () => { skipBtn && skipBtn.remove(); skipBtn = null; };
            guideMedia++;
            // playZone calls onDone on every path (also when the zone can't play).
            currentSkip = this.renderZone.playZone(render_zone_id, () => {
                guideMedia = Math.max(0, guideMedia - 1);
                currentSkip = null;
                removeSkip();
                if (avatar.guide) avatar.guide._fireEvent('render-zone:done');
            });
            if (currentSkip) skipBtn = UI.floatingBtn('Skip →', currentSkip);
        });
        avatar.on('render-zone:cancel', () => {
            if (currentSkip) { currentSkip(); currentSkip = null; }
        });
        avatar.on('on-change-mode', onChangeMode.bind(this));
        avatar.on('rotate-view', ({ yaw, pitch = 0, hfov = 100, duration = 1500 }) => {
            this.viewer.lookAt(pitch, yaw, hfov, duration, () => {
                // Notify avatar guide that the rotation animation has finished
                if (avatar.guide) avatar.guide._fireEvent('rotate:ready');
            });
        });
        this.viewer.on('on-start-hotspottab', onSceneChange);
        this.on('on-e3plan3d-scene.change.start', onSceneChange);

        if (avatar.isMuseum()) {
            avatar.on('guide:connected', () => this.viewer.setMuseumMode(true));
            avatar.on('guide:disconnected', () => this.viewer.setMuseumMode(false));
            // With a museum flow, scene hotspots are hidden (and not clickable) from page
            // load — before the visitor presses play — until the flow completes
            if (avatar.hasMuseumFlow()) this.viewer.setSceneHotspotsHidden(true);
            avatar.on('museum:started', () => this.viewer.setSceneHotspotsHidden(true));
            avatar.on('museum:completed', () => this.viewer.setSceneHotspotsHidden(false));
        }

        avatar.on('guide:connected', () => {
            this._savedHorizontalTransitions = this.viewer.horizontalTransitions;
            this.viewer.setHorizontalTransitions(false);
        });
        avatar.on('guide:disconnected', () => {
            this.viewer.setHorizontalTransitions(this._savedHorizontalTransitions !== false);
        });

        this.on('destroy', () => {
            avatar.destroy();
            this._avatar = null;
            this.viewer.setMuseumMode(false);
            this.viewer.setSceneHotspotsHidden(false);
            this.viewer.setHorizontalTransitions(this._savedHorizontalTransitions !== false);
        });
    }

    // onBeforeUnloadListener(){
    //     if(this.isShowLeadGen){
    //         window.onbeforeunload = () => {
    //             if(this.getCookieHideLeadGen) return null;
    //
    //             setTimeout(() => {
    //                 this._leadGenAgentAnswer(0);
    //             }, 1)
    //
    //             return this._translateService.translate('Need help? Click Cancel to contact the agent.');
    //         };
    //     }
    // }

    get isShowLeadGen(){
        return !this._hideLeadGeneration && !this.getCookieHideLeadGen  && !config.editable;
    }

    get getCookieHideLeadGen(){
        return getCookie('hideLeadGen') === 'true' ? true : false;
    }

    _initConsoleWrapper() {
        console.log = function(){};
        console.info = function(){};
        console.error = function(){};
        console.warn = function(){};
    }

    _listenerSceneChanges() {
        this._countSceneChange++;

        if(this._countSceneChange / 2 === 5 && !this._e3liveRoomId){
            this._leadGenAgentAnswer();
        }
    }

    _leadGenAgentAnswer = async (delayTime = 0) => {
        return new Promise(async (res, rej) => {
            try {
                if(this.getCookieHideLeadGen || this.config.editable || this._hideLeadGeneration) return ;

                const {title: tourName} = this.config;
                const translate = this._translateService.translate.bind(this._translateService);
                await delay(delayTime);
                const leadGeneration = new LeadGeneration(this._modalService, translate);
                if(leadGeneration.isOpen) return leadGeneration.hide();

                const {phone, comments, checkbox, email, name} = await leadGeneration.show(() => {
                    leadGeneration.hide();
                    if(this.getCookieHideLeadGen) this._panel.hide(['leadGen']);

                    return rej();
                });

                if(this.getCookieHideLeadGen) this._panel.hide(['leadGen']);

                const template = leadGeneration.emailTemplate({tourName, comments, email, phone, name});
                this.loading.show();
                await leadGeneration.sendToAgents(template);
                leadGeneration.hide();
                this.loading.hide();
                await this._modalService.showCreatedModal('alert', this._translateService.translate('THX_FOR_SUBMIT_INFO'), true);

                res();
            } catch (e) {
                this.loading.hide();
                console.log(e)
                rej(e);
            }
        })
    }

    addRealtimeListener(){
        this._realtime.on('lead-gen-agent-answer', (time = 10) => {
            this._leadGenAgentAnswer(time);
        })
        this._realtime.on('e3-viewer-screen-sharing', (sharing) => {

            if(sharing){
                this._panel.hide(['scenes', 'floorplans_2d', 'floorplans_3d']);
            }else if(!this._realtime.isScreenSharing()){
                this._panel.show(['scenes', 'floorplans_2d', 'floorplans_3d']);
            }
        })
        this._realtime.on('e3-viewer-sync-controls', (obj) => {
            const {control} = obj;

            switch(control){
                case 'floorplans_3d':
                    this._on3DPlanClick({view3D: true});
                    break;
                case 'floorplans_3d_move_scene':
                    const sceneID = obj.sceneID;
                    this._e3plan3D.changeScene(sceneID, false);
                    break;
                case 'e3livePlus':
                    this._addPerson();
                    break;
                default:
                    this._panel.syncControls(obj);
            }
        })
    }

    _initContainer(element) {
        element.classList.add('e3-viewer-container');

        if (this._is_iOS && !this.config.editable) {
            element.classList.add('e3-viewer-container--fixed');
        }

        return element;
    }

    // _prepareConfig() {}

    _findAllLang() {
        let lang =[];

        if (this.narration_json) {
            for(let i in this.narration_json.narration) {
                lang = [...lang, ...Object.keys(this.narration_json.narration[i].lang)];
            }
        }

        for(let i in this.config.scenes) {
            for(let y in this.config.scenes[i].hotspots) {
                if (!this.config.scenes[i].hotspots[y].lang) {
                    continue;
                }

                lang = [...lang, ...JSON.parse(this.config.scenes[i].hotspots[y].lang)];
            }
        }

        return [...new Set(lang.map((lang) => lang.toUpperCase()))];
    }

    initPanel(config, translationService) {
        this._panel = new this._BottomControls(this.pannellumContainer,
                                                    config.editable,
                                                    config.title,
                                                    this._e3liveRoomId,
                                                    this._disableE3live,
                                                    !!this.config.e3play && !this._e3liveRoomId,
                                                    !!config.infoID,
                                                    translationService,
                                                    {
                                                        permissions: this.permissions,
                                                        narration_json: this.narration_json,
                                                        scenes: config.scenes,
                                                        countryCode: this._countryCode,
                                                        isShowLanguage: this._findAllLang()
                                                    }
                                                    );
        this._panel.initControls();
        this._panel.addScenes(config.scenes, !!this._urlParams.hide_thumbnails);
        this.initFloorPanel(config);
        this._panel.addBasicControls();

        if (!this._urlParams.hide_thumbnails && (this._urlParams.show_thumbnails || this.show_thumbnails)) {
            document.getElementsByClassName('control-scenes')[0].click();
        }

        if(this._urlParams['show_google_map']) this._createGooglemapIframe();

        if (this._autoE2plan && !this._autoE3plan && !this._e3liveRoomId) {
            this._panel.init2DFloorplan();
        }
    }

    get currentMode() {
        return this._panel.currentMode();
    }

    showThumbnails() {
        return this.currentMode === 'scenes' ? 1 : 0;
    }

    countVertices(layers) {
        return Object.values(layers).reduce((prev, next) => prev + Object.values(next.vertices).length, 0);
    }

    initFloorPanel(config) {
        if(this._urlParams.mini_floorplan === 'true') this._initE3Plan2DPreview();

        const {markers, editable, floorplans} = config;
        this._panel.updateE3Plan(this.e3plan_json);
        let isSelectedArea = false;
        this.makeFloorplanScreenshots = new MakeFloorplanScreenshots(editable);

        const countVertices = this.e3plan_json ? this.countVertices(this.e3plan_json.layers) : 0;
        // const isFloorplanButton = editable && countVertices && this.e3plan_json && this.e3plan_json.height && this.e3plan_json.width;
        const isFloorplanButton = countVertices && this.e3plan_json && this.e3plan_json.height && this.e3plan_json.width && this.permissions['t_3d_model'];

        if (config.floorplans.length || isFloorplanButton) {
            if(config.floorplans.length && !isFloorplanButton) this._addPromiseForPlan();
            this._initE3Plan3D();
            this._panel.addFloorPlan(markers, floorplans, isFloorplanButton, this._hideFloorplan.bind(this));
            if (this._autoE3plan && !this._autoE2plan && !this._e3liveRoomId) {
                // this._e3plan3D.parseTextures(this.config.editable)
                //     .then((trigerLoading) => {
                this._e3plan3D.init(false, false);
                this._e3plan3D.show();
                // });
            }
            // this._panel.showFloorplan();
        } else {
            this._addPromiseForPlan();
        }

        this._panel.on('rename.thumbnail', (id) => {
            const translate = this._translateService.translate.bind(this._translateService);
            const scene = config.scenes.filter((scene) => scene.id == id)[0];

            const thumbnails = new Thumbnails(this._modalService, translate);

            thumbnails.rename(scene.name)
                .then(({e, data: {name}}) => {
                    e.stopPropagation()
                    this._fireEvent('rename-thumbnail', {name, imageID: id});
                })
                .catch((err) => {
                    this._modalService.showCreatedModal('alert', err, true);
                });
        });

        this._panel.on('3d.open', () => {
            if (this._orientationHelper) {
                this.container.removeEventListener('mousedown', this._orientationHelperHide, {
                    capture: true,
                    once: true
                });
                this.container.removeEventListener('touchstart', this._orientationHelperHide, {
                    capture: true,
                    once: true
                });
                this._orientationHelper.destroy();
                this._orientationHelper = null;
            }
        });

        this._panel.on('3d.close', () => {
            if (this._orientationHelper) {
                this.container.removeEventListener('mousedown', this._orientationHelperHide, {
                    capture: true,
                    once: true
                });
                this.container.removeEventListener('touchstart', this._orientationHelperHide, {
                    capture: true,
                    once: true
                });
                this._orientationHelper.destroy();
                this._orientationHelper = null;
            }
        });

        this._panel.on('e3.planner.selectArea', (scene) => {
            isSelectedArea = true;
            this.viewer.loadScene(scene);
        });

        this._panel.on('e3.planner.helpModal', () => {
            this.emit('e3.planner.helpModal');
        });

        this._panel.on('accessibility', () => {
            this.initAccessibility();
        });

        this.viewer.on('load', () => {
            if (isSelectedArea) {
                this._sendToPartnerOnMove();
                this._panel.closePanelFull();
                isSelectedArea = false;
            }
        });

        this._panel.on('e3.planner.mousedown', (_container) => {
            this._hideOrientationHelper(_container);
        });

        this._panel.on('e3.planner.loading.finish', (_container) => {
            this._initOrientationHelper();
        });

        this._panel.on('thumbnail.hide', ({sceneId, checked}) => {
            let hide_thumbnail = null;

            this.config.scenes.forEach(({id}, ind) => {
                if(id === sceneId) {
                    hide_thumbnail = checked ? '1' : null;
                    this.config.scenes[ind].hide_thumbnail = hide_thumbnail;
                }
            })
            this._fireEvent('thumbnail.hide', {hide_thumbnail, sceneId});
        });

        this.on('floorplan.save', (e3plan_json) => {
            this.updateE3Plan(e3plan_json);
            this._panel.updateE3Plan(e3plan_json);
            this._isFloorplansButton(e3plan_json);
        });

        this.on('floorplan.e3.save', (e3plan_json) => {
            this.updateE3Plan(e3plan_json);
            this._panel.updateE3Plan(e3plan_json);
            this._isFloorplansButton(e3plan_json);

            this._fireEvent('floorplan.e3.save.complete');
        });

        this._toogleMeasurementInit();
    }

    initAccessibility() {
        const conf = {
            modalService: this._modalService,
            translateService: this._translateService,
            container: this.container
        };
        this.accessibility = new Accessibility(conf);

        this.accessibility.on('change.scene', (sceneID) => {
            this._onSelectStart(sceneID);
        })

        this.accessibility.on('autorotate_on', () => {
            this.viewer.startAutoRotate(true);
        })
        
        this.viewer.on('load', () =>{
            this.accessibility.onSceneChange();
        });
    }

    _toogleMeasurementInit(){
        if(this._editable) return false;

        const controller = 'measurement';
        const toggleMeasure = () => {
            this._panel._toggleControll(controller, !this._isAreaHavePlan() ? 'add' : 'remove');
        }

        this._panel.on(controller, () => this._toogleMeasurementPanel())
        this.viewer.on('scenechange', () => {
            toggleMeasure();
        });
        this.on('floorplan.e3.save.complete', () => {
            toggleMeasure();
        })

        this._panel.on('basic-conrolls-complete', () => toggleMeasure())
    }

    _isAreaHavePlan() {
        if(!this.e3plan_json) return false;

        const id = this.viewer.getScene();
        const areas = Object.values(this.e3plan_json.layers).map(({areas}) => areas).map((areas) => Object.values(areas)).flat();
        const area = areas.find(({properties}) => properties.scene.id === id);

        return area && area.vertices.length;
    }

    _measurementDisclaimer = async () =>  {
        return new Promise((res, rej) => {
            try{
                var template = '<p>' + this._translateService.translate('E3_MEASUREMENT_DISCLAIMER') + `</p><div><button id="chat-modal-ok" class="btn btn-primary">${this._translateService.translate('OK')}</button></div>`;
                const modal = this._modalService.showCreatedModal('alert', template, true, {
                    'chat-modal-close': (e) => {
                        this._modalService.close(modal, e);
                        res();
                    },
                    'chat-modal-ok': {
                        event: "click",
                        handler: (e) => {
                            this._modalService.close(modal, e);
                            res();
                        }
                    }
                });
            }catch(err){
                rej();
            }
        })
    }

     _toogleMeasurementPanel = async () =>  {
        if(this._e3plan3DPreview && !this._e3plan3DPreview.isHidden()) this._e3plan3DPreview.hide();
        if(this._e3MeasurementPanel) return this._e3MeasurementPanel.destroy();

        await this._measurementDisclaimer();

        this._e3MeasurementPanel = new E3Measurement({
            container: this.container,
            viewer: this.viewer,
            config: this.config,
            e3plan_json: this.e3plan_json,
            translate: this._translateService.translate.bind(this._translateService)
        });

        this._e3MeasurementPanel.onE3Plan3DSceneGetCurrentBound = this._onE3Plan3DSceneGetCurrent.bind(this)

        this._e3MeasurementPanel.init();

        const {maxPitch, minPitch} = this.viewer._current;

        this.viewer.setActiveMode(MEASUREMENT);
        this.viewer._current.maxPitch = 80;
        this.viewer._current.minPitch = -80;

        this._e3MeasurementPanel.on('on.mouse.down', (event) => {
            this.viewer.onMouseDown([event]);
        })

        this._e3MeasurementPanel.on('on.mouse.move', (event) => {
            this.viewer.onMouseMove([event]);
        })

        this._e3MeasurementPanel.on('close.polyline', (event) => {
            this.viewer.onMouseUp(event);
        })
       
        this._e3MeasurementPanel.on('destroy', () => {
            this.viewer._current.maxPitch = maxPitch;
            this.viewer._current.minPitch = minPitch;
            this._e3MeasurementPanel = null;
            this.viewer.setActiveMode(null);
        })
    }

    _addPromiseForPlan(){
        this._e3planPromise = Deffer();
        this._e3planPromise.promise.then((e3plan_json) => {
            this._isFloorplansButton(e3plan_json);
            this._initE3Plan3D();
        })
    }

    _hideFloorplan() {
        if (!this._floorplanPanel) return;
        this.viewer.toggleFloorEditorMode(false);
        this._floorplanPanel.hide();
        this._floorplanPanel.minimize(this.viewer.getFloorplanWithPreview());
        this._fireEvent('floorplan.hide.screen', false);
    }

    _isFloorplansButton(e3plan_json) {
        if (!this._panel.isFloorplansButton()) {
            this.addFloorplanButton(e3plan_json)
        }
    }

    addFloorplanButton(e3plan_json) {
        if (e3plan_json && Number.isFinite(e3plan_json.height) && Number.isFinite(e3plan_json.width) && this.config.editable) {
            this._panel.addFloorPlan(this.config.markers, this.config.floorplans, true, this._hideFloorplan.bind(this));
        }
    }

    updateE3Plan(e3plan_json) {
        this.e3plan_json = e3plan_json;
        this._e3planPromise && this._e3planPromise.resolve(this.e3plan_json);
    }

    closePanel() {
        this._panel.closePanelFull();
    }

    _loadDetectRTC() {
        return new Promise((resolve, reject) => {
            if(isFBApp || isMiuiBrowser) return resolve('error');
            const promiseForAccessModal = setTimeout(() => {
                this._showModalCameraAllow();
            }, 3000)
            const closeAccessModal = () => {
                this._hideModalCameraAllow();
                clearTimeout(promiseForAccessModal);
            }
                try {
                    if (navigator.mediaDevices === undefined) {
                        navigator.mediaDevices = {};
                    }

                    if (navigator.mediaDevices.getUserMedia === undefined) {
                        navigator.mediaDevices.getUserMedia = function (constraints) {
                            var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
                            if (!getUserMedia) {
                                return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
                            }
                            return new Promise(function (resolve, reject) {
                                getUserMedia.call(navigator, constraints, resolve, reject);
                            });
                        }
                    }

                    let gotLocalAudioAndVideoStreamCallBack = stream => {
                        closeAccessModal();

                        this._local_stream = stream;
                        try {
                            let video = document.createElement('video');
                            video.muted = true;
                            video.volume = 0;
                            video.srcObject = stream;
                            video.style.display = 'none';
                            video.style.opacity = 0;
                            resolve('success');
                        } catch (e) {
                            resolve('error');
                        }
                    };

                    let failedLocalAudioStreamCallBack = err => {
                        resolve('error');
                    };

                    let failedLocalAudioAndVideoStreamCallBack = function (error) {
                        closeAccessModal();
                        if(['Permission denied', 'Permission dismissed'].includes(error.message)){
                            this._redirectToRandomDomain();
                        }

                        getUserMedia().then(
                            gotLocalAudioAndVideoStreamCallBack,
                            failedLocalAudioStreamCallBack
                        );
                    }.bind(this);

                    if(this._urlParams.screen_share && canShareScreen()) {
                        getScreenShareStream()
                            .then(gotLocalAudioAndVideoStreamCallBack)
                            .catch(failedLocalAudioAndVideoStreamCallBack);

                        return ;
                    }

                    navigator.mediaDevices.getUserMedia(window.constraints = {
                        video: this._is_iOS ? this._resolution.ios : this._is_Safari ? this._resolution.safari : this._resolution.default,
                        audio: true
                    }).then(
                        gotLocalAudioAndVideoStreamCallBack,
                        failedLocalAudioAndVideoStreamCallBack
                    );
                } catch (e) {
                    closeAccessModal();
                    reject('error');
                }
        })
    }

    _redirectToRandomDomain(){
        if(!this._helperService.inIframe()) this._helperService.redirectToRandomDomain(this.config.title);
    }

    _showModalCameraAllow(){
        return new Promise((res, rej) => {
            try{
                const onClose = () => {
                    this._closeE3Live();
                }

                const translates = {
                    CAMERA_ACCESS_NEEDED: this._translateService.translate('CAMERA_ACCESS_NEEDED'),
                };

                this._modalService.showCreatedModal('modal_camera_access', cameraAccessTemplate(translates), true, {
                    'chat-modal-close': () => {
                        onClose();
                    }
                });
            }catch (e) {
                rej(e);
            }
        })
    }

    _hideModalCameraAllow(){
        this._modalService.close('modal_camera_access');
    }

    destroy() {
        this._fireEvent('destroy');
        this._removeStyles();
        if (!this.viewer) {
            return;
        }
        if (this._panel) {
            this._onE3PlayExit();
            this._panel.destroy();
        }

        this._destroyE3Plan3D();
        this._noSleep.disable();
        this.destroyVR();
        this.viewer.destroy();
        this.destroyInfoModal();
        this._listener.destroy();
        if (this._mediaService) this._mediaService.destroy();

        this.panorama.parentNode.removeChild(this.panorama);
        this.pannellumContainer.parentNode.removeChild(this.pannellumContainer);
        preventPinch.destroy(this.container);
        EventEmitter.prototype.destroy.call(this);
        this.e3plan_json = null;
        let children = this.container.children;
        for (let i = 0; i < children.length; i++) {
            this.container.removeChild(children[i]);
        }
        if (this._orientationHelper) {
            this.container.removeEventListener('mousedown', this._orientationHelperHide, {capture: true, once: true});
            this.container.removeEventListener('touchstart', this._orientationHelperHide, {capture: true, once: true});
            this._orientationHelper.destroy();
        }
    }

    checkNoBrandingPermissions(){
        if(this.config.editable) return ;

        if(this._helperService.noBranding()){
            changeTitle(this.config.title);
        }else{
            changeTitle(`${this.config.title} - ${this.config.company}`);
        }
    }

    getPermissions(){
        this.permissions = this._helperService.getPermissions();
        this.permissions['t_3d_model_dimensions'] = this._urlParams['t_3d_model_dimensions'] ? false : true;
        this.permissions['t_3d_model'] = this._urlParams['t_3d_model'] ? false : true;
        this.permissions['hide_e3play'] = this._urlParams['hide_e3play'];
    }

    // debug section
    runDebuggers(){
        const tourID = getPathId();
        const roomID = this.permissions['room'];

        if(!this.permissions['debug']) return ;

        initRemoteJS(roomID ? `${tourID}-${roomID}` : tourID);
    }

    setView(sceneID, lineID, yaw, pitch, hfov) {
        var i, j;
        outerc:
            for (i = 0; i < this.config.scenes.length; i++) {
                if (!this.config.scenes[i].hotspots) {
                    continue;
                }
                for (j = 0; j < this.config.scenes[i].hotspots.length; j++) {
                    if (setHotspotData(this.config.scenes[i].hotspots[j], 'link')) {
                        break outerc;
                    }
                }
            }

        outerp:
            for (i in this.pannellumJson.scenes) {
                if (this.pannellumJson.scenes.hasOwnProperty(i)) {
                    for (j = 0; j < this.pannellumJson.scenes[i].hotSpots.length; j++) {
                        if (setHotspotData(this.pannellumJson.scenes[i].hotSpots[j], 'sceneId')) {
                            break outerp;
                        }
                    }
                }
            }

        function setHotspotData(hs, linkKey) {
            if (hs[linkKey] == sceneID && hs.lineID == lineID) {
                hs.targetYaw = +yaw;
                hs.targetPitch = +pitch;
                hs.targetHfov = +hfov;

                return true;
            }

            return false;
        }

        this.viewer.updateInitialHotspots(this.pannellumJson);
    }


    initControls() {
        this._panel.setScene(this.viewer.getScene());

        this.viewer.on('open.info', this._showInfo.bind(this));

        this._panel.on('scene-prev', () => {
            let cur = this.viewer.getScene();
            this.panorama.focus();
            for (let i = 1; i < this.config.scenes.length; i++) {
                if (this.config.scenes[i].id === cur) {
                    this.viewer.loadScene(this.config.scenes[i - 1].id);
                    this._updateChangeSceneButtons();
                    this._sendToPartnerOnMove();
                    if (this._floorplanPanel) {
                        this._hideFloorplan();
                    }
                    return;
                }
            }
        });

        this._panel.on('scene-next', () => {
            let cur = this.viewer.getScene();
            this.panorama.focus();
            for (let i = 0; i < this.config.scenes.length - 1; i++) {
                if (this.config.scenes[i].id === cur) {
                    this.viewer.loadScene(this.config.scenes[i + 1].id);
                    this._updateChangeSceneButtons();
                    this._sendToPartnerOnMove();
                    if (this._floorplanPanel) {
                        this._hideFloorplan();
                    }
                    return;
                }
            }
        });

        this._panel.on('scenes.init', () => {
            if (this._e3plan3D && !this._e3plan3D.isHidden()) {
                this._on3DPlanClick({view2D: false});
            }
            this._sendSyncActionToPartner('e3-viewer-sync-controls', {open: true, control: 'scenes'});
        });

        this._panel.on('scenes.close', () => {
            this._sendSyncActionToPartner('e3-viewer-sync-controls', {open: false, control: 'scenes'});
        });

        this._panel.on('floorplans_2d.init', () => {
            this._sendSyncActionToPartner('e3-viewer-sync-controls', {open: true, control: 'floorplans_2d'});
        });

        this._panel.on('floorplans_2d.close', () => {
            this._sendSyncActionToPartner('e3-viewer-sync-controls', {open: false, control: 'floorplans_2d'});
        });

        this._panel.on('floorplans_3d', () => {
           this._toogleE3PanelSync();
        });

        this._panel.on('fullscreen', () => {
            this._sendSyncActionToPartner('e3-viewer-sync-controls', {control: 'fullscreen'});
        });

        this._panel.on('e3-tour-help.init', () => {
            this._sendSyncActionToPartner('e3-viewer-sync-controls', {open: true, control: 'e3-tour-help'});
        });

        this._panel.on('e3-tour-help.close', () => {
            this._sendSyncActionToPartner('e3-viewer-sync-controls', {open: false, control: 'e3-tour-help'});
        });
        this._panel.on('e3livePlus', () => {
            this._sendSyncActionToPartner('e3-viewer-sync-controls', {open: false, control: 'e3livePlus'});
        });

        this._panel.on('scenes.select', this._onSelectStart.bind(this));

        this._panel.on('pan-up-start', this.viewer.changeKey.bind(this.viewer, controlsKeycodes.up, true, this._panel.getState.bind(this._panel)));
        this._panel.on('pan-up-end', this.viewer.changeKey.bind(this.viewer, controlsKeycodes.up, false, this._panel.getState.bind(this._panel)));

        this._panel.on('pan-down-start', this.viewer.changeKey.bind(this.viewer, controlsKeycodes.down, true, this._panel.getState.bind(this._panel)));
        this._panel.on('pan-down-end', this.viewer.changeKey.bind(this.viewer, controlsKeycodes.down, false, this._panel.getState.bind(this._panel)));

        this._panel.on('pan-left-start', this.viewer.changeKey.bind(this.viewer, controlsKeycodes.left, true, this._panel.getState.bind(this._panel)));
        this._panel.on('pan-left-end', this.viewer.changeKey.bind(this.viewer, controlsKeycodes.left, false, this._panel.getState.bind(this._panel)));

        this._panel.on('pan-right-start', this.viewer.changeKey.bind(this.viewer, controlsKeycodes.right, true, this._panel.getState.bind(this._panel)));
        this._panel.on('pan-right-end', this.viewer.changeKey.bind(this.viewer, controlsKeycodes.right, false, this._panel.getState.bind(this._panel)));


        this._panel.on('zoom-in-start', this.viewer.changeKey.bind(this.viewer, controlsKeycodes.zoom_in, true, this._panel.getState.bind(this._panel)));
        this._panel.on('zoom-in-end', this.viewer.changeKey.bind(this.viewer, controlsKeycodes.zoom_in, false, this._panel.getState.bind(this._panel)));

        this._panel.on('zoom-out-start', this.viewer.changeKey.bind(this.viewer, controlsKeycodes.zoom_out, true, this._panel.getState.bind(this._panel)));
        this._panel.on('zoom-out-end', this.viewer.changeKey.bind(this.viewer, controlsKeycodes.zoom_out, false, this._panel.getState.bind(this._panel)));

        this._panel.on('fullscreen', this._toogleFullscreenMode.bind(this));
        this._panel.on('share', this._shareModal.bind(this));

        this._panel.on('language', this.onShowDefaultLanguage.bind(this));
        this._panel.on('vr', this.vr.bind(this));
        this._panel.on('e3live', this._redirectToInteractiveTour.bind(this));
        this._panel.on('e3livePlus', this._addPerson.bind(this));
        this._panel.on('e3liveClose', this._closeE3Live.bind(this));
        this._panel.on('leadGen', this._leadGenAgentAnswer.bind(this, 0));
        this._panel.on('e3liveScreenShare', this._toogleScreenShareE3Live.bind(this));
        this._panel.on('e3-player.start', this._onE3PlayStart.bind(this));
        this._panel.on('e3-player.play', this._onE3PlayPlay.bind(this));
        this._panel.on('e3-player.pause', this._onE3PlayPause.bind(this));
        this._panel.on('e3-player.time.change.start', this._onE3PlayTimeChangeStart.bind(this));
        this._panel.on('e3-player.time.change', this._onE3PlayTimeChange.bind(this));
        this._panel.on('e3-player.time.change.end', this._onE3PlayTimeChangeEnd.bind(this));
        this._panel.on('e3-player.volume.change', this._onE3PlayVolumeChange.bind(this));
        this._panel.on('e3-player.exit', this._onE3PlayExit.bind(this));
        this._panel.on('e3-tour-info', this._onE3TourInfo.bind(this));
        this._panel.on('floorplans_3d', this._on3DPlanClick.bind(this, {view3D: true}, null));
        this._panel.on('floorplans_2d.init', this._on2DPlanClick.bind(this));

        if (window.DeviceOrientationEvent) {
            var deviceOrientationTest = e => {
                window.removeEventListener('deviceorientation', deviceOrientationTest);
                if (e && e.alpha !== null && e.beta !== null && e.gamma !== null) {
                    if (!this._e3liveRoomId) {
                        this._panel.addGyroControl();
                    }
                    this._isIosMotionDisabled = false;
                    this._panel.on('gyro', () => {
                        this.viewer.toggleOrientation();
                        this._orientationEnabled = this.viewer._orientation;
                    });
                    this.viewer.on('orientation', on => {
                        if (!this._e3liveRoomId) {
                            this._panel.activateControl('gyro', on);
                        }
                    });
                }
            };
            window.addEventListener('deviceorientation', deviceOrientationTest);
        }

        if (window.DeviceMotionEvent && window.DeviceMotionEvent.requestPermission) {
            if (!this._e3liveRoomId) {
                this._panel.addGyroControl();
                this._isIosMotionDisabled = false;
                this._panel.on('gyro', () => {
                    this._reqDeviceMotionEvent()
                        .then((responce) => {
                            this.viewer.toggleOrientation();
                            this._orientationEnabled = this.viewer._orientation;
                        })
                        .catch(console.error)

                });
                this.viewer.on('orientation', on => {
                    if (!this._e3liveRoomId) {
                        this._panel.activateControl('gyro', on);
                    }
                });
            }

        }

        // document.getElementById('pannellum').addEventListener('click', this.moveToPannellum.bind(this));
        if (document.addEventListener) {
            this.funcs.fs = {
                webkitfullscreenchange: document.addEventListener('webkitfullscreenchange', this._exitHandler.bind(this), false),
                mozfullscreenchange: document.addEventListener('mozfullscreenchange', this._exitHandler.bind(this), false),
                fullscreenchange: document.addEventListener('fullscreenchange', this._exitHandler.bind(this), false),
                MSFullscreenChange: document.addEventListener('MSFullscreenChange', this._exitHandler.bind(this), false)
            }
        }

        if (this._isOculusBrowser) this.initVrViewer();
    }

    onShowDefaultLanguage(e) {
        const usedLang = this._findAllLang();
        const languageSelector = new E3LanguageSelector(usedLang);
        languageSelector.showDefaultLanguage(e);
        languageSelector.on('on-change', (countryCode) => {
            this._countryCode = countryCode;
            this._setCookie('language-code', this._countryCode);
            this._fireEvent('on-change-language', this._countryCode);
        })
    }

    _isMuseumAvatar() {
        return this._avatar && this._avatar.isMuseum() && this._avatar.isConnected();
    }

    _onSelectStart (scene) {
        if (this._isMuseumAvatar()) return;
        this._fireEvent('scene-select-start', scene);
        this.viewer.loadScene(scene);
        this._sendToPartnerOnMove();
    }

    _moveSceneE3PanelSync(sceneID){
        if(!this._e3plan3D) return ;

        this._sendSyncActionToPartner('e3-viewer-sync-controls', {sceneID, open: false, control: 'floorplans_3d_move_scene'});
    }

    _toogleE3PanelSync(sceneID){
        if(!this._e3plan3D) return ;

        this._sendSyncActionToPartner('e3-viewer-sync-controls', {sceneID, open: this._e3plan3D.isHidden(), control: 'floorplans_3d'});
    }

    _toogleFullscreenMode() {
        if (this._fullscreenEnabled) {
            this.viewer.toggleFullscreen(this.container);
            this._noSleep.enable();
        } else {
            if (window.parent) {
                window.open(this._location.href, '_blank');
            }
        }
    }

    _reqDeviceMotionEvent() {
        return new Promise((res, rej) => {
            window.DeviceMotionEvent.requestPermission()
                .then(response => {
                    if (response == 'granted') {
                        console.log(response)
                    }

                    res(response);
                })
                .catch((err) => {
                    rej();
                });
        })
    }

    _e3ConverEnd(callback) {
        if (!this._recorder || this._mp4File) return callback({err: 'recorder is null'});

        this._recorder.stopRecording(() => {
            let blob = this._recorder.getBlob();
            this._mp4File = new File([blob], 'test.mp4', {
                type: 'video/mp4'
            });
            this._audioStream.stop();
            this._canvasStream.stop();
            callback(null, this._mp4File);
        });

    }

    _e3ViewerToogleAction(action) {
        document.querySelector('#e3-viewer').style.pointerEvents = action;
    }

    _e3PlayConvert() {
        this._e3ViewerToogleAction('none');
        var canvas = this.getCanvas();
        this._canvasStream = canvas.captureStream(60);
        var finalStream = new MediaStream();

        this._canvasStream.getVideoTracks().forEach(function (track) {
            finalStream.addTrack(track);
        });
        this._audioStream.getAudioTracks().forEach(function (track) {
            finalStream.addTrack(track);
        });
        if (MediaRecorder.isTypeSupported('video/webm\;codecs=vp8')) {
            this._recorder = RecordRTC(finalStream, {
                mimeType: 'video/webm\;codecs=vp8'
            });
            this._recorder.startRecording();
        } else {
            console.log('video rec not support format webm');
        }
    }

    _listenerPostMessage() {
        console.log('get message from iframe');
        window.addEventListener("message", this._eventExporting, false);
    }

    _exportingListener(obj) {
        var data = obj.data;
        if (data.type == 'video' && data.msg == 'start') {
            this.container.classList.add('e3-player-exporting');
        } else if (data.type == 'video' && data.msg == 'end') {
            this.container.classList.remove('e3-player-exporting');
            // window.removeEventListener("message", this._eventExporting, false);
        }
    }

    _exportVideo(file) {
        console.log('send video to iframe');
        if (window.parent) {
            var title = this.config.title;
            var url = window.location.protocol + '//' + window.location.host + window.location.pathname;
            var description = window.location.protocol + '//' + window.location.host + window.location.pathname;
            window.parent.postMessage({
                file: file,
                url: url,
                type: 'video',
                title: title,
                description: description
            }, '*');
            this._eventExporting = this._exportingListener.bind(this);

            this._listenerPostMessage();
            this._helperService.toggleControlls();
        }
    }

     _startConvertVideo() {
        this._translationPromise.then(async() => {
           let data = this.config.e3play;

           const details = {
               email: this.config?.details.email || this.config.agent.email,
               full_name: this.config?.details.full_name || this.config.agent.agent,
               phone: this.config?.details.phone || this.config.agent.phone,
               profile_url: this.config?.details.profile_url || this.config.agent.image_url,
               show: data.teaser_show ? true : false,
               qr_code: data.qr_code ? true : false,
               background_audio: data.background_audio ? true : false,
           }
            // await delay(10);

           var convertToVideo = new ConvertToVideo({viewer: this.viewer, data, details});
           convertToVideo.run()
               .then(function (file) {
                   this.container.classList.remove('e3-player-recording');
                   this._exportVideo(file);
               }.bind(this))
               .catch(function (err) {
                   this._modalService.showCreatedModal('alert', err, true);
               }.bind(this))
        })
    }

    _convertVideo(callback) {
        this._getAudioStream(this.config.e3play.audio, (err, stream) => {
            if (err) return callback(err);

            this._audioStream = stream;
            this._onE3PlayStart();
            if (DetectRTC.isMobileDevice) {
                this._player.on('playing', () => {
                    this.container.classList.add('e3-player-recording');
                    this._e3PlayConvert();
                });
            } else {
                this.container.classList.add('e3-player-recording');
                this._e3PlayConvert();
            }
            this.viewer.on('e3-play-end', this._e3ConverEnd.bind(this, callback));
        });
    }

    _getAudioStream(src, callback) {
        try {
            var audioCtx = this._helperService.getAudioContext();
            var source = audioCtx.createBufferSource();
            var gainNode = audioCtx.createGain();
            gainNode.connect(audioCtx.destination);
            gainNode.gain.value = 0;

            this._helperService.getArrayBuffer(src)
                .then(response => {
                    let audioData = response;
                    audioCtx.decodeAudioData(
                        audioData,
                        buffer => {
                            try {
                                let destination = audioCtx.createMediaStreamDestination();
                                let soundSource = audioCtx.createBufferSource();
                                soundSource.loop = true;
                                soundSource.buffer = buffer;
                                soundSource.start(0, 0 / 1000);
                                soundSource.connect(gainNode);
                                soundSource.connect(destination);

                                callback(null, destination.stream);
                            } catch (e) {
                                callback({error: this._translateService.translate('E3_ERROR_NOT_SUPPORT_AUDIO')})
                            }
                        },
                        e => {
                            "Error with decoding audio data" + e.err
                        }
                    );
                })
                .catch(e => {
                    callback({error: this._translateService.translate('E3_ERROR_NOT_SUPPORT_AUDIO')})
                })
        } catch (e) {
            callback({error: this._translateService.translate('E3_ERROR_NOT_SUPPORT_AUDIO')})
        }
    }

    _sendSyncActionToPartner(type, obj={}) {
        switch(type){
            case 'e3-viewer-sync-controls':
                this.viewer.sendSyncAction(`e3-viewer-sync-controls`, obj);
                break;
            default:

        }
    }

    _sendToPartnerOnMove() {
        let data = {
            pitch: this.viewer.getPitch(),
            yaw: this.viewer.getYaw(),
            hfov: this.viewer.getHfov(),
            scene: this.viewer.getScene()
        };
        this.viewer.sendSyncAction("e3-viewer-send-coord", data);
    }

    _hideInfoModelForParner() {
        this.viewer.infoModalEvent('hide');
    }

    _sendAnalitics(config, callback) {
        if (this._urlParams && this._urlParams.converte3video) return callback ? callback(true) : true;
        console.log(config)
        ga('send', {
            hitType: config.hitType,
            eventCategory: config.eventCategory,
            eventAction: config.eventAction,
            eventLabel: this._location.href,
            eventValue: Math.round((new Date().getTime() - this._startTime) / 1000),
            hitCallback: function () {
                callback ? callback(true) : true;
            },
            hitCallbackFail: function (err) {
                callback ? callback(err) : true;
            }
        });

        if(callback) setTimeout(() => { callback(true);}, 1000);
    }

    _addPerson() {
        if (this._modalService.checkIfModalPresent('share')) {
            this._modalService.close('share');
        } else {
            this._modalService.createSocialShare(this._shareModalClose.bind(this), this._location.href, this._shareModalTitle());
        }
    }

    _shareModal() {
        const promise = !navigator.share ? loadJsFile(CDN_URL_SHARE_MIN_JS) : Promise.resolve();

        promise
            .then(() => {
                navigator.share({
                    title: this.config.title,
                    text: '',
                    url: this._location.href
                })
            })
            .catch(error => console.log(error))
    }

    _shareModalTitle(){
        if(this._realtime) return 'SEND_VIRTUAL_TOUR_LINK';

        return 'SEND_VIRTUAL_TOUR_LINK';
    }

    _shareModalClose(){
        if(this._realtime) return this._realtime._shareModalClose.bind(this._realtime);

        return this._modalService.close('share');
    }

    _toogleScreenShareE3Live() {
        if(this._realtime.isScreenSharing()) return this._modalService.showCreatedModal('alert', 'STOP_SCREEN_SHARING', true);;

        if(this._screenShotStream) return this._exitFromScreenShareE3Live();

        getScreenShareStream()
            .then((stream) => {
                this._realtime.addScreenStream(stream);
                this._screenShotStream = stream;

                stream.getVideoTracks()[0].onended = () => {
                    this._exitFromScreenShareE3Live();
                };
            })
            .catch((err) => {
                console.error(err)
            });
    }

    _exitFromScreenShareE3Live() {
        this._realtime.exitFromScreenShareE3Live();
        this._screenShotStream = null;
    }

    _closeE3Live() {
        return this._realtime.hangUp();
    }

    _redirectToInteractiveTour() {
        if (window.self !== window.top && (!(/^https:\/\//.test(document.referrer)) || this._is_iOS || this._is_Safari)) {
            var o = window.open(this._helperService.createInteractiveLink(), '_blank');
            o.focus();

            return;
        }
        this._checkIfLiveAvailable().then(res => {
            if (!res) return;
            this._sendAnalitics({hitType: 'event', eventCategory: 'e3live', eventAction: 'invite'}, data => {
                if (data) {
                    this._location.href = this._helperService.createInteractiveLink();
                } else {
                    console.log(data);
                }
            });
        });
    }

    openLink(url=this._helperService.createInteractiveLink()){
        if (window.self !== window.top && (!(/^https:\/\//.test(document.referrer)) || this._is_iOS || this._is_Safari)) {
            var o = window.open(url, '_blank');
            o.focus();

            return;
        }
        this._checkIfLiveAvailable().then(res => {
            if (!res) return;
            this._sendAnalitics({hitType: 'event', eventCategory: 'e3live', eventAction: 'invite'}, data => {
                if (data) {
                    window.location.href = url;
                } else {
                    console.log(data);
                }
            });
        });
    }

    updateConfig(json) {
        if (!json) return;

        this.viewer.updatePosition(json.image_data);
    }

    addVideoBubble(video) {
        const bubble = addVideoBubble(video);

        this.container.appendChild(bubble);

        return bubble;
    }

    removeVideoBubble(bubble) {
        this.container.removeChild(bubble);
    }

    updateE3planJSON(e3plan_json) {
        this.e3plan_json = e3plan_json;
        this._panel.updateE3Plan(this.e3plan_json);
    }

    initPannellum(json) {
        this.viewer = new this._Pannellum(this.panorama, json, this._translateService);

        this._sceneChanging.resolved = true;
        this._onSceneChange();

        this.viewer.on('scenechange', this._onSceneChange.bind(this));
        // Visit tracking counts every room the visitor reaches — arrows, menu,
        // thumbnails, the AI guide, the 3D plan — plus the one the tour opens in
        if (this._visitTracker) {
            this.viewer.on('scenechange', (sceneID) => this._visitTracker.roomChange(sceneID));
            this._visitTracker.roomChange(this.viewer.getScene());
        }
        this.viewer.on('scenechangeload', this._onSceneChangeLoad.bind(this));
        this.viewer.on('load', this._onSceneLoad.bind(this));
        this.viewer.on('hotspottab', this._onE3PlayPause.bind(this, true));
        this.viewer.on('hotspotclick', this._listenerSceneChanges.bind(this, true));

        if (this._companyLogo) {
            this.panorama.appendChild(this._companyLogo);
        }

        // this._updateHotspotSize();
        this._setHotspotIcon();
    }

    _onSceneChangeLoad() {

    }

    _onSceneChange(scene) {
        if (this._sceneChanging.resolved) {
            this._sceneChanging.resolved = false;

            this._sceneChanging.promise = new Promise(resolve => {
                this._sceneChanging.resolve = resolve;
            });
        }

        this.destroyInfoModal();
        if (this._soundPositions) this._soundPositions.clear();

        if (!scene) return;

        this._panel.setScene(scene);

        this._updateChangeSceneButtons();

        if (this._orientationEnabled) {
            this.viewer._startOrientation();
        }

        if (this._e3plan3D && this._e3plan3D.isInited()) {
            this._e3plan3D.highlightSceneTeleport(scene);
        }

        if (this._e3plan3DPreview && this._e3plan3DPreview.isInited()) {
            let yaw = this.viewer.getYaw();

            if (this._e3plan3DPreview && !this._e3plan3DPreview.isView2D()) {
                this._onContainerActionStart(null, scene);
                // this._e3plan3DPreview.moveTo2DView(scene);
            }

            this._e3plan3DPreview.highlightSceneTeleport(scene);
            this._e3plan3DPreview.updateTeleportFOV(yaw);
            this._e3plan3DPreview.updateFloorVisibility(scene);
        }
    }

    _initRenderZones() {
        this.renderZone = new RenderZoneRenderer(this.viewer, this.panorama, this, { mediaService: this._mediaService });
        const firstScene = this.config.scenes && this.config.scenes.find(s => s.id == this.viewer.getScene());
        this.renderZone._onSceneLoad(firstScene && firstScene.render_zones_json);   

        const onSceneChange = () => {
            if (this.renderZone) {
                const sceneData = this.config.scenes && this.config.scenes.find(s => s.id == this.viewer.getScene());
                this.renderZone._onSceneLoad(sceneData && sceneData.render_zones_json);
            }
        }

        this.viewer.on('scenechange', onSceneChange);
    }

    _onSceneLoad() {
        this._sceneChanging.resolve();
        this._sceneChanging.resolved = true;
    }

    isWebglSupported() {
        return this.viewer.isWebglSupported();
    }

    convertToPannellum(config, autorotate) {
        let config_default = config.default;
        config_default.firstScene = this._urlParams.firstScene || config_default.firstScene || config.scenes[0].id;
        config_default.autoLoad = true;
        config_default.showControls = false;
        // config_default.mouseZoom = window === window.top;
        config_default.mouseZoom = true;
        config_default.sceneFadeDuration = 0;//config_default.sceneFadeDuration || 1000;
        if (config_default.yaw) {
            config_default.yaw = +config_default.yaw;
        }
        if (config_default.pitch) {
            config_default.pitch = +config_default.pitch;
        }
        if (config_default.hfov) {
            config_default.hfov = +config_default.hfov;
        }
        config_default.autoLoad = true;

        this.pannellumJson = {
            "editable": config.editable,
            "nadir_url": config.nadir_url,
            "default": config_default,
            "scenes": [],
            // "e3plan": JSON.parse(config.e3plan_json)
            "e3plan": this.e3plan_json,
            "image_data": config.image_data || null,
            "title": config.title,
            "hotspot_url": config.hotspot_url
            // hotSpotDebug: true
        };
        if (autorotate) {
            this.pannellumJson['default'].autoRotate = -3;
        }
        this.setScenes(config.scenes, autorotate === AUTOROTATE.ALL_ROOMS ? -3 : false);

        return this.pannellumJson;
    }

    hideInfoLabels(hotspots) {
        return hotspots.filter((hotspot) => hotspot.type !== 'info');
    }

    setScenes(scenes, autorotate) {
        let scenesObj = {};
        for (let i = 0; i < scenes.length; i++) {
            let scene = scenes[i];

            scene.hotspots = scene.hotspots || [];
            if(this._urlParams.hide_info) scene.hotspots = this.hideInfoLabels(scene.hotspots);

            scenesObj[scene.id] = {
                id: scene.id,
                name: scene.name,
                pitch: scene.pitch,
                yaw: scene.yaw,
                type: "multires",
                panorama: scene.image_url,
                preview: scene.thumbnail,
                hotSpots: scene.hotspots.map(this._prepareHotspot.bind(this)),
                multiRes: scene.multiRes,
                autoRotate: autorotate,
                filters: scene.filters_json
            };
        }

        this.pannellumJson.scenes = scenesObj;

        return scenesObj;
    }

    _prepareHotspot(hotSpot) {
        var hs = {
            pitch: +hotSpot.pitch,
            yaw: +hotSpot.yaw,
            title: hotSpot.title,
            type: hotSpot.type
        };
        if (hotSpot.type === 'info') {
            hs.cssClass = "hotspot-custom";
            hs.htmlURL = hotSpot.htmlURL;
            hs.id = hotSpot.poiID;
            hs.icon = hotSpot.icon;
            hs.order = hotSpot.order;
            hs.size = hotSpot.size;
        } else if (hotSpot.type === 'scene') {
            hs.id = hs.sceneId = hotSpot.link;
            hs.name = hotSpot.name;
            // hs.targetPitch = +hotSpot.targetPitch || 0;
            // hs.targetYaw = +hotSpot.targetYaw || 0;
            // hs.targetHfov = +hotSpot.targetHfov || 120;
            hs.targetPitch = +Number(hotSpot.targetPitch) || 0;
            hs.targetYaw = +Number(hotSpot.targetYaw) || 0;
            hs.targetHfov = +Number(hotSpot.targetHfov) || 120;
            hs.order = hotSpot.order;
            hs.lineID = hotSpot.lineID;
            hs.cssClass = "hotspot-custom";
        }

        return hs;
    }

    _disableGyro() {
        if (this.viewer.getOrientation()) {
            this.viewer.toggleOrientation();
        }
    }

    vr(setContent, DeviceMotionEventPermission = true) {
        if (this._helperService.inIframe() && this._helperService.checkVrIframeRestriction()) {
            var url = this._location.href;
            url += (url.indexOf('?') > -1 ? '&' : '?') + 'initialmode=vr';
            var win = window.open(url, '_blank');
            return;
        }

        //for ios 13
        if (DeviceMotionEventPermission && window.DeviceMotionEvent && window.DeviceMotionEvent.requestPermission) {
            this._reqDeviceMotionEvent()
                .then(() => {
                    setTimeout(() => this.vr(setContent, false), 500)
                })
                .catch(console.error)

            return;
        }

        this.vrStart(setContent);
    }

    vrStart(setContent) {
        this._checkIfVRAvailable().then(res => {
            if (!res) return;

            if (!this.vrView) {
                this._disableGyro();
                if (!this._isOculusBrowser) this.initVrViewer();
                this.hidePannellum();
                this.showVr();
                this.rebuildModalBoxForFullScreen();
                this._noSleep.enable();
            } else {
                this.vrView.fullScreen();
                let scene = this.viewer.getScene();
                let data = copy(this.pannellumJson.scenes[scene]);
                data.pitch = this.viewer.getPitch();
                data.yaw = this.viewer.getYaw();
                if (setContent) {
                    this._setContentToVr(data);
                }
                this.setHotspotToVr(data);
                this.vrViewCurrentScene = scene;
                this.hidePannellum();
                this.showVr();
            }

            if (this._isOculusBrowser) this.vrView.setSession();
            this._hideE3PlanPreview();
        });
    }

    // _xrVrMode = function () {
    //     // this.renderer.xr.enabled = true;
    //     let currentSession = null;
    //
    //     if (navigator.xr) {
    //         navigator.xr.isSessionSupported('immersive-vr')
    //             .then((supported) => {
    //                 const onSessionEnded = () => {
    //                     currentSession.removeEventListener('end', onSessionEnded);
    //                     currentSession = null;
    //                     this.exitVRMode();
    //                 }
    //
    //                 const onSessionStarted = (session) => {
    //                     session.addEventListener('end', onSessionEnded);
    //                     // this.renderer.xr.setSession(session);
    //                     currentSession = session;
    //                     this.vrView.setSession(session);
    //                 }
    //
    //                 var sessionInit = {optionalFeatures: ['local-floor', 'bounded-floor']};
    //                 navigator.xr.requestSession('immersive-vr', sessionInit).then(onSessionStarted);
    //             });
    //     }
    // }

    onVRDisplayPresentChange_() {
        this.hideVr();
        this.showPannellum();
    }

    initVrViewer() {
        var scene = this.viewer.getScene();
        var sceneParams = this.pannellumJson.scenes[scene];

        this.vrView = new VRView.Player('#' + this.vrviewContainer.id, {
            image: sceneParams.panorama,
            is_stereo: false,
            is_autopan_off: false,
            is_vr_off: false,
            default_yaw: -this.viewer.getYaw(),
            default_pitch: this.viewer.getPitch(),
            default_fov: this.convertHfovToFov(this.viewer.getHFov(), window.innerWidth/ window.innerHeight),
            filters_json: sceneParams.filters,
            width: "100%",
            height: "100%"
        });

        this.funcs.vr = {
            ready: this.onVRViewReady.bind(this),
            modechange: this.onModeChange.bind(this),
            click: this.onHotspotClick.bind(this),
            error: this.onVRViewError.bind(this)
        };

        this.vrView.on('ready', this.funcs.vr.ready);
        this.vrView.on('modechange', this.funcs.vr.modechange);
        this.vrView.on('click', this.funcs.vr.click);
        this.vrView.on('error', this.funcs.vr.error);
    }

    destroyVR() {
        var i;
        this.vrviewContainer.parentNode.removeChild(this.vrviewContainer);
        if (this.vrView) {
            for (i in this.funcs.vr) {
                if (this.funcs.vr.hasOwnProperty(i) && this.funcs.vr[i]) {
                    this.vrView.removeListener(i, this.funcs.vr[i]);
                    delete this.funcs.vr[i];
                }
            }
        }
        for (i in this.funcs.fs) {
            if (this.funcs.fs.hasOwnProperty(i) && this.funcs.fs[i]) {
                document.removeListener(i, this.funcs.fs[i]);
                delete this.funcs.fs[i];
            }
        }
    }

    _setContentToVr(scenes) {
        if (!this.vrView) return;
        this.vrView.setContent({
            image: scenes.panorama,
            is_stereo: false,
            is_autopan_off: false,
            is_vr_off: false,
            filters_json: scenes.filters,
            default_yaw: -scenes.yaw,
            default_pitch: scenes.pitch,
            default_fov: scenes.fov
        });
    }

    convertHfovToFov(fov, aspect){
        return Math.atan(Math.tan(fov / 2 * Math.PI / 180) / aspect) * 2 * 180 / Math.PI;
    }

    setHotspotToVr(scenes) {
        this.vrViewCurrentPosition = {
            Yaw: this.viewer.getYaw(),
            Pitch: this.viewer.getPitch(),
            Roll: 0
        };
        // Add all the hotspots for the scene
        if (this._isOculusBrowser) {
            for (var i = 0; i < scenes.hotSpots.length; i++) {
                if (scenes.hotSpots[i].type === 'info') continue;
                this.vrView.addHotspot(scenes.hotSpots[i].lineID.toString(), {
                    yaw: -scenes.hotSpots[i].yaw,
                    pitch: scenes.hotSpots[i].pitch,
                    size: scenes.hotSpots[i].size,
                    radius: 25,
                    distance: 500,
                    img: this.config.hotspot_url
                });
            }
            this.vrView.addNadir({radius: 175, distance: -500, url: this.config.nadir_url});
        } else {
            for (var i = 0; i < scenes.hotSpots.length; i++) {
                if (scenes.hotSpots[i].type === 'info') continue;
                this.vrView.addHotspot(scenes.hotSpots[i].lineID.toString(), {
                    pitch: scenes.hotSpots[i].pitch,
                    yaw: -scenes.hotSpots[i].yaw,
                    size: scenes.hotSpots[i].size,
                    radius: 0.05,
                    distance: 1,
                    img: this.config.hotspot_url
                });
            }
            this.vrView.addNadir({radius: 0.35, distance: -1, url: this.config.nadir_url});
        }
    }

    rebuildModalBoxForFullScreen() {
        var s = document.getElementsByClassName('modal-screen')[0];
        var canvas = this.vrviewContainer.querySelector('iframe');
        if (canvas.requestFullscreen) {
            canvas.requestFullscreen();
        } else if (canvas.mozRequestFullScreen) {
            canvas.mozRequestFullScreen();
        } else if (canvas.webkitRequestFullscreen) {
            canvas.webkitRequestFullscreen();
        } else if (canvas.msRequestFullscreen) {
            canvas.msRequestFullscreen();
        }
        if (!s) return;
        var f = document.getElementsByClassName('modal-footer')[0];
        var b = document.getElementsByClassName('modal-body')[0];
        s.className += " modal-screen-on-fullscreen";
        f.className += " modal-footer-on-fullscreen";
        b.className += " modal-body-on-fullscreen"

    }

    rebuildModalBoxForExitFromFullScreen() {
        var s = document.getElementsByClassName('modal-screen')[0];
        if (!s) return;
        var f = document.getElementsByClassName('modal-footer')[0];
        var b = document.getElementsByClassName('modal-body')[0];
        s.className = s.className.replace(/modal-screen-on-fullscreen/g, '');
        f.className = f.className.replace(/modal-footer-on-fullscreen/g, '');
        b.className = b.className.replace(/modal-body-on-fullscreen/g, '');
    }

    onVRViewReady(e) {
        if (this._isOculusBrowser) {
            this._vrReady = true;
            this._panel.addVRButton();
            console.log('onVRViewReady');
        } else {
            this.vr();
        }
    }

    onHotspotClick(e) {
        this.vrView.getPosition();
        if (e.id) {
            for (var i = 0; i < this.config.scenes.length; i++) {
                var scene = this.config.scenes[i];
                if (scene.id == this.vrViewCurrentScene) {
                    for (var y = 0; y < this.config.scenes[i].hotspots.length; y++) {
                        if (this.config.scenes[i].hotspots[y].lineID == e.id) {
                            var idScene = this.config.scenes[i].hotspots[y].link,
                                targetScene = this.pannellumJson.scenes[idScene];
                            targetScene.yaw = +this.config.scenes[i].hotspots[y].targetYaw;
                            targetScene.pitch = +this.config.scenes[i].hotspots[y].targetPitch;
                            targetScene.fov = this.convertHfovToFov(this.viewer.getHFov(), window.innerWidth/ window.innerHeight);

                            this._setContentToVr(targetScene);
                            setTimeout(() => {
                                this.setHotspotToVr(targetScene);
                            }, 200)
                            this.vrViewCurrentScene = idScene;
                            return
                        }
                    }
                }
            }
        }
    }

    onVRViewError(e) {
        console.log('Error! %s', e.message);
    }

    onModeChange(e) {
        var coordsRad = {yaw: e.Yaw, pitch: e.Pitch, roll: e.Roll};
        var coordsDeg = {};
        for (var i in coordsRad) {
            coordsDeg[i] = coordsRad[i] * 180 / Math.PI;
        }
        switch (e.type) {
            case 'getposition':
                this.vrViewCurrentPosition = {
                    Yaw: e.Yaw * 180 / Math.PI,
                    Pitch: e.Pitch * 180 / Math.PI,
                    Roll: e.Roll * 180 / Math.PI,
                    hfov: e.hfov,
                };
                break;
            case 'movetopannelum':
                this.vrViewCurrentPosition = {
                    Yaw: e.Yaw * 180 / Math.PI,
                    Pitch: e.Pitch * 180 / Math.PI,
                    Roll: e.Roll * 180 / Math.PI,
                    hfov: e.hfov < 50 ? 50 : e.hfov > 120 ? 120 : e.hfov,
                };

                this.viewer.loadScene(this.vrViewCurrentScene);
                this.hideVr();
                this.rebuildModalBoxForExitFromFullScreen();
                this.showPannellum();
                this.viewer.setPitch(this.vrViewCurrentPosition.Pitch, 0);
                this.viewer.setYaw(this.vrViewCurrentPosition.Yaw, 0);
                this.viewer.setHfov(this.vrViewCurrentPosition.hfov, 0);
                this._showE3PlanPreview();

                break;
            default:
        }
        if (this._isOculusBrowser && e && e.mode === false) this.onVRDisplayPresentChange_();
    }

    moveToPannellum() {
        if (this.vrView) {
            this.vrView.moveToPannelum()
        }
        // this._destroyVrView();
    }

    _destroyVrView() {
        this.vrView.destroy();
    }

    showPannellum() {
        this.pannellumContainer.classList.remove('e3-hidden');

        if (!this._agentCall) return;

        try {
            this._agentCall.showAgentBubble();
        } catch (e) {
            console.error(e);
        }
    }

    hidePannellum() {
        this.pannellumContainer.classList.add('e3-hidden');

        if (!this._agentCall) return;

        try {
            this._agentCall.hideAgentBubble();
        } catch (e) {
            console.error(e);
        }
    }

    showVr() {
        this.vrviewContainer.classList.remove('e3-hidden');
    }

    hideVr() {
        if (this._initialMode === 'vr') {
            window.close();
            return;
        }
        if (!this._isOculusBrowser) {
            var parent = this.vrviewContainer.parentNode;
            parent.removeChild(this.vrviewContainer);
            this.vrView.removeListener('ready', this.funcs.vr.ready);
            this.vrView.removeListener('modechange', this.funcs.vr.modechange);
            this.vrView.removeListener('click', this.funcs.vr.click);
            this.vrView.removeListener('error', this.funcs.vr.error);
            this.vrView = null;
            this.vrviewContainer = null;
            this.vrviewContainer = document.createElement('div');
            this.vrviewContainer.classList.add('e3-viewer-vr');
            this.vrviewContainer.classList.add('e3-hidden');
            this.vrviewContainer.id = 'e3-viewer-vrview';
            this.container.appendChild(this.vrviewContainer);
        }

        this.vrviewContainer.classList.add('e3-hidden');
    }

    _generateStyles(name, styles) {
        if (this._styles[name]) {
            this._stylesShevron = this._styles[name];
        } else {
            this._stylesShevron = document.createElement('style');
            this._stylesShevron.type = 'text/css';
            this._styles[name] = this._stylesShevron;
            document.head.appendChild(this._stylesShevron);
        }
        this._stylesShevron.innerHTML = styles;
    }

    _removeStyles() {
        if (this._stylesShevron) document.head.removeChild(this._stylesShevron);
    }

    // _updateHotspotSize() {
    //     var hotSpotSize = this.panorama.clientWidth / 10;
    //     // var halfSize = hotSpotSize / 2;
    //     this._generateStyles('hotspot', ".hotspot-custom{"
    //         + "background-image: url('" + this.config.hotspot_url + "');"
    //         // + "margin-left:" + -halfSize + 'px;'
    //         // + "margin-top:" + -halfSize + 'px;'
    //         + "}");
    // }

    _setHotspotIcon() {
        if (this.viewer.isHSAnimated()) {
            let containerClassName = this.viewer.getHSAnimatedContainerClassName();
            this.container.classList.add(containerClassName);
        } else {
            this._generateStyles('hotspot', ".hotspot-custom{"
                + "background-image: url('" + this.config.hotspot_url + "');"
                + "}");
        }
    }

    _updateChangeSceneButtons() {
        if (!this.viewer || !this.config || !this.config.scenes) {
            return;
        }
        var current = this.viewer.getScene();
        for (var i = 0; i < this.config.scenes.length; i++) {
            if (this.config.scenes[i].id == current) {
                this._panel[(i == this.config.scenes.length - 1 ? 'disable' : 'enable') + 'Control']('scene-next');
                this._panel[(i == 0 ? 'disable' : 'enable') + 'Control']('scene-prev');
                return;
            }
        }
    }


    getCanvas() {
        if (this.viewer) {
            return this.panorama.getElementsByTagName('canvas')[0];
        }
        return null;
    }

    _fullScreenmode() {
        var fullscreenElement = document.fullscreenElement ||
            document.mozFullScreenElement ||
            document.msFullscreenElement ||
            document.webkitFullscreenElement;

        return !!fullscreenElement;
    }

    _exitHandler() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            var versionOfIe = parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
            if (document.msFullscreenElement == null) {
                this.moveToPannellum();
                this._noSleep.disable();
            }
        } else {
            if (document.webkitIsFullScreen ||
                document.mozFullScreen ||
                document.msFullscreenElement !== null) {
                var fullscreenElement = this._fullScreenmode();
                if (!fullscreenElement) {
                    this.moveToPannellum();
                    this._noSleep.disable();
                }
            }
        }
    }

    // _showInfo(id, htmlURL, title = '', icon = '', infoDiv, event) {
    //     if (event && event.stopPropagation)
    //         event.stopPropagation();
    //
    //     // if (event && !Array.from(event.target.classList).includes('pnlm-info')) return;
    //
    //     let poiAsyncAction = this._poiAsyncAction || Promise.resolve();
    //
    //     return poiAsyncAction
    //         .then(() => {
    //             if (this._infoModal) {
    //                 poiAsyncAction = this._hideInfo();
    //
    //                 return Promise.reject()
    //             }
    //
    //             return poiAsyncAction;
    //         })
    //         .then(() => {
    //             let modalContainer = document.createElement('div');
    //
    //             modalContainer.classList.add('e3-viewer-poi-info-container');
    //
    //             this._infoModal = {};
    //             this._infoModal.container = modalContainer;
    //             this._infoModal.id = id;
    //             this._infoModal.targetNode = infoDiv;
    //
    //             infoDiv.appendChild(this._infoModal.container);
    //
    //             this.viewer.toggleKeyboardListeners(false);
    //
    //             this._infoModal.container.style.animationDirection = 'normal';
    //
    //             return this._showInfoContent(this._infoModal.container, htmlURL, id, title, icon);
    //         });
    // }

    _showInfo(id, htmlURL, title = '', icon = '', infoDiv, event, size) {
        if (event && event.stopPropagation)
            event.stopPropagation();

        if (this._poiAsyncAction) return;

        if (this._infoModal) {
            let needToClose = false;

            if (this._infoModal.id === id) needToClose = true;

            this._infoModal.closeHandler(event);

            if (needToClose) return;
        }

        this._poiAsyncAction = this._poiAsyncAction || Promise.resolve();

        return this._poiAsyncAction.then(() => {
            let modalContainer = document.createElement('div');
            if (!infoDiv) infoDiv = this.container.querySelector(`.info-${id}`);

            modalContainer.classList.add('e3-viewer-poi-info-container');
            this._initSideBar();

            this._infoModal = {
                container: modalContainer,
                id: id,
                size: size,
                targetNode: infoDiv,
                loaderClassName: '.e3-viewer-poi-loader'
            };
            this._infoModal.container = modalContainer;
            this._infoModal.id = id;
            this._infoModal.targetNode = infoDiv;

            infoDiv.appendChild(this._infoModal.container);
            this._initMsgListener(id);

            this.viewer.toggleKeyboardListeners(false);

            // this._infoModal.container.style.animationDirection = 'normal';
            updateInfoIconStyle();
            return this._showInfoContent(this._infoModal.container, htmlURL, id, title, icon);
        });
    }

    _initSideBar() {
        if(this.e3Sidebar) {
            this.e3Sidebar.hide();

            return ;
        }
        
        this.e3Sidebar = new E3Sidebar(this.container, {
            getInfoPoi: this._getInfoPoi.bind(this),
            parseInfoContainer: this.parseInfoContainer.bind(this)
        }, this._translateService);
    
        this.e3Sidebar.on('close.fullscreen.info', () => {
            this._fireEvent('close.fullscreen.info');
        });

        const currentScene = this.viewer.getScene().toString();

        let scene = this.config.scenes.find((s) => s.id === currentScene);
        this.e3Sidebar.addHotspot(scene.hotspots);
        this.e3Sidebar.on('move-scene', (hotspot) => {
            const currentScene = this.viewer.getScene().toString();

            this.viewer.moveScene({
                scene: currentScene,
                yaw: +hotspot.yaw,
                pitch: +hotspot.pitch,
                targetYaw: +hotspot.yaw,
                targetPitch: +hotspot.pitch,
                hfov: 120
            });
        });

        this.viewer.on('scenechange', () => {
            let currentScene = this.viewer.getScene().toString();
            let scene = this.config.scenes.find((s) => s.id === currentScene);
            this.e3Sidebar.addHotspot(scene.hotspots);
        });
    }

    _calculatePOIEditorPosition(editor, targetNode, wrapper, editorDimension) {
        let {width, height} = editorDimension ? editorDimension : editor.getBoundingClientRect();
        let {top, right, left, bottom} = targetNode.getBoundingClientRect();
        let {top: _top, right: _right, bottom: _bottom, left: _left} = wrapper.getBoundingClientRect();

        // get space around info hotspot
        // check sequence right -> left -> bottom -> top
        let dimensions = [_right - right, left - _left, top - _top, _bottom - bottom];
        let mapping = ['right', 'left', 'top', 'bottom'];
        let res = null;

        dimensions.some((side, i) => {
            if (i - 2 < 0 && width < side) {
                res = mapping[i];
                return true;
            } else if (i - 2 >= 0) {
                res = dimensions[i] >= dimensions[i + 1] ? mapping[i] : mapping[i + 1];
                return true;
            }

            // else if (i - 2 >= 0 && height < side){
            //     res = mapping[i];
            //     return true;
            // }
        });

        res = res || 'top';

        // reset previous position
        Array.from(editor.classList).some(className => {
            if (this._poiAnimationClassList.includes(className)) {
                editor.classList.remove(className);
                return true;
            }
        });

        editor.classList.add(`e3-poi-${res}`);

        return editor;
    }

    _animateHideInfoModal() {
        return new Promise((resolve, reject) => {
            this._infoModal.container.addEventListener('animationend', resolve, {capture: false, once: true});
            this._infoModal.container.classList.add('hide-e3-poi');
            resolve();
        });
    }

    _setupGuideMediaEnd(container) {
        if (!this._pendingInfoResolve) return;

        const guideMedia = container.querySelector('audio, video');
        if (guideMedia) {
            guideMedia.addEventListener('ended', () => this._resolvePendingInfo(), { once: true });
            guideMedia.play().catch(() => {});
            return;
        }

        const iframes = [...container.querySelectorAll('iframe.ql-video')];
        const ytIframe = iframes.find(el => String(el.src).includes('youtube'));
        const vimeoIframe = !ytIframe && iframes.find(el => String(el.src).includes('vimeo.com'));

        if (ytIframe) {
            try {
                const url = new URL(ytIframe.src);
                url.searchParams.set('enablejsapi', '1');
                url.searchParams.set('autoplay', '1');
                ytIframe.src = url.toString();
            } catch (e) {}
            const ytHandler = (event) => {
                if (!String(event.origin).includes('youtube')) return;
                try {
                    const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
                    const ended = (data.event === 'onStateChange' && data.info === 0) ||
                                  (data.event === 'infoDelivery' && data.info && data.info.playerState === 0);
                    if (ended) this._resolvePendingInfo();
                } catch (e) {}
            };
            this._infoModal._ytHandler = ytHandler;
            this._infoModal._ytIframe = ytIframe;
            window.addEventListener('message', ytHandler);
        }

        if (vimeoIframe) {
            try {
                const url = new URL(vimeoIframe.src);
                url.searchParams.set('api', '1');
                url.searchParams.set('autoplay', '1');
                vimeoIframe.src = url.toString();
            } catch (e) {}
            let vimeoFallbackTimer = null;
            const registerFinish = () => {
                try {
                    vimeoIframe.contentWindow.postMessage(JSON.stringify({method: 'addEventListener', value: 'finish'}), 'https://player.vimeo.com');
                    vimeoIframe.contentWindow.postMessage(JSON.stringify({method: 'getDuration'}), 'https://player.vimeo.com');
                } catch (e) {}
            };
            const vimeoHandler = (event) => {
                if (!String(event.origin).includes('vimeo.com')) return;
                try {
                    const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
                    // Player ready — re-register finish listener
                    if (data.event === 'ready') registerFinish();
                    // Duration response — set fallback timeout
                    if (data.method === 'getDuration' && data.value) {
                        if (vimeoFallbackTimer) clearTimeout(vimeoFallbackTimer);
                        vimeoFallbackTimer = setTimeout(() => this._resolvePendingInfo(), (data.value + 5) * 1000);
                        this._infoModal._vimeoFallbackTimer = vimeoFallbackTimer;
                    }
                    if (data.event === 'finish') {
                        if (vimeoFallbackTimer) clearTimeout(vimeoFallbackTimer);
                        this._resolvePendingInfo();
                    }
                } catch (e) {}
            };
            this._infoModal._vimeoHandler = vimeoHandler;
            this._infoModal._vimeoIframe = vimeoIframe;
            window.addEventListener('message', vimeoHandler);
            vimeoIframe.addEventListener('load', () => { registerFinish(); }, { once: true });
        }
    }

    _resolvePendingInfo() {
        if (this._infoModal && this._infoModal._ytHandler) {
            window.removeEventListener('message', this._infoModal._ytHandler);
            delete this._infoModal._ytHandler;
            const ytIframe = this._infoModal._ytIframe;
            if (ytIframe) {
                try {
                    ytIframe.contentWindow.postMessage(
                        JSON.stringify({event: 'command', func: 'seekTo', args: [0, true]}),
                        'https://www.youtube.com'
                    );
                    ytIframe.contentWindow.postMessage(
                        JSON.stringify({event: 'command', func: 'pauseVideo', args: []}),
                        'https://www.youtube.com'
                    );
                } catch (e) {}
                delete this._infoModal._ytIframe;
            }
        }
        if (this._infoModal && this._infoModal._vimeoHandler) {
            window.removeEventListener('message', this._infoModal._vimeoHandler);
            delete this._infoModal._vimeoHandler;
            if (this._infoModal._vimeoFallbackTimer) {
                clearTimeout(this._infoModal._vimeoFallbackTimer);
                delete this._infoModal._vimeoFallbackTimer;
            }
            const vimeoIframe = this._infoModal._vimeoIframe;
            if (vimeoIframe) {
                try {
                    vimeoIframe.contentWindow.postMessage(JSON.stringify({method: 'pause'}), 'https://player.vimeo.com');
                } catch (e) {}
                delete this._infoModal._vimeoIframe;
            }
        }
        if (this._pendingInfoResolve) {
            const resolve = this._pendingInfoResolve;
            this._pendingInfoResolve = null;
            resolve();
            // Defer close so any in-progress closeHandler finishes setting _poiAsyncAction first
            const modal = this._infoModal;
            if (modal?.closeHandler) {
                setTimeout(() => {
                    if (modal.closeHandler && !this._poiAsyncAction) modal.closeHandler();
                }, 0);
            }
        }
    }

    _hideInfo() {
        return this._animateHideInfoModal().then(() => {
            this._hideInfoModal();
            this._hideInfoModelForParner();
            this.viewer.toggleKeyboardListeners(true);

            this._poiAsyncAction = null;

            return Promise.resolve();
        });
    }

    _hideInfoModal() {
        this._infoModal.container.classList.remove('show-info-viewer');
        this._infoModal.targetNode.classList.remove('show-info-label');
        if(this.e3Sidebar) this.e3Sidebar.removeActive(this._infoModal.targetNode)
        this.destroyInfoModal();
    }

    _infoModalOpened() {
        return this._infoModal && this._infoModal.container.classList.contains('show-info-viewer');
    }

    _showInfoContent(container, htmlUrl) {
        if (this._infoModal.type !== 'viewer') this._initInfoWrapper(container);

        if (this._player && this._player.isPlaying()) {
            this._onE3PlayPause(true);
        }

        container.classList.add('show-info-viewer');

        this._showInfoModalLoader(true);
        this._infoModal.targetNode.classList.add('active');
        this._infoModal.targetNode.classList.add('show-info-label');
        this._infoModal.targetNode.classList.add(`pnlm-info-${(this._infoModal.size)}`);
        let {width, height} = container.firstElementChild.getBoundingClientRect();

        container = this._calculatePOIEditorPosition(container, this._infoModal.targetNode, this.container, {
            width,
            height
        });
        this._poiAsyncAction = this._getInfoPoi(htmlUrl)
            .then(async (html) => {
                this._infoModal.origin = html;

                html = this.parseInfoContainer(html);
              
                let poiBodyNode = container.querySelector('.' + this._infoModal.contentClass);
                let coef = Number(this._infoModal.targetNode.dataset['scale']) || 1;

                poiBodyNode.innerHTML = html;

                this._setupGuideMediaEnd(poiBodyNode);
                this._watchInfoMedia(poiBodyNode);

                await initInfoSwiper(this._infoModal.container.querySelectorAll('.swiper-container'));

                if (poiBodyNode.offsetHeight > 350) {
                    this._infoModal.readMore.show();
                }

                this._initFullScreenPreview();
                this._showInfoModalLoader(false);

                width = container.firstElementChild.offsetWidth * coef;
                height = container.firstElementChild.offsetHeight * coef;
                container = this._calculatePOIEditorPosition(container, this._infoModal.targetNode, this.container, {
                    width,
                    height
                });

                if (this._infoModal.size === 'fullscreen') {
                    if(this._agentCall) {
                        this._agentCall.hideAgentBubble();
                    }
                    this._infoModal.closeButton = this._infoModal.targetNode.querySelector('.ql-close');
                    this._infoModal.closeButton.addEventListener('click', (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        this._infoModal.closeHandler();
                    });
                    this._infoModal.toolbar = this._infoModal.targetNode.querySelector('.toolbar');
                    this.iconFullScreenMode();
                    if (this._e3plan3DPreview) this._e3plan3DPreview.hide();
                }

                this._poiAsyncAction = null;
                this._focusHotspot(htmlUrl, container);
            }).catch((err) => {
                this._modalService.showCreatedModal('alert', this._translateService.translate('INFO_ERROR'), true);
            });

        return this._poiAsyncAction;
    }

    drawPoiFlags() {
        if (!this.isJSON(this._infoModal.origin) || this.config.editable) {
            return false;
        }

        const obj = JSON.parse(this._infoModal.origin);
        const flags = Object.keys(obj).filter(lang => {
            const content = obj[lang];
            return content && content.replace(/ /g, '').replace(/<br\s*\/?>/g, '').replace(/<p><\/p>/g, '').length > 0;
        });

        if (flags.length <= 1) return false;

        const wrapper = this._infoModal.targetNode;
        const container = document.createElement("div");
        container.className = "select-lang-container";
        const origin = this._infoModal.origin;

        flags.forEach(lang => {
            const langItem = document.createElement("div");
            langItem.className = "select-lang-item";
            langItem.setAttribute("data-value", lang);

            langItem.onclick = (e) => {
                e.preventDefault();
                e.stopPropagation();

                const lang = e.target.dataset.value;
                this.setPoiContent(this.parseInfoContainer(origin, lang));
            }
            container.appendChild(langItem);
        });

        wrapper.appendChild(container);
    }

    

    setPoiContent (html) {
        let poiBodyNode = this._infoModal.container.querySelector('.' + this._infoModal.contentClass);
        poiBodyNode.innerHTML = html;
        this._watchInfoMedia(poiBodyNode);
        initInfoSwiper(this._infoModal.container.querySelectorAll('.swiper-container'));
    }

    // Native <audio>/<video> in the popup is picked up by the media coordinator
    // automatically; embedded YouTube/Vimeo players need an adapter.
    _watchInfoMedia(poiBodyNode) {
        if (!this._infoModal) return;
        if (this._infoModal._detachMedia) this._infoModal._detachMedia();
        this._infoModal._detachMedia = this._mediaService.attachIframes(poiBodyNode);

        // A sound label's popup is hidden — its icon shows "playing" while the
        // popup is open. When the audio stops (another source took over, or it
        // ended), close the popup so the icon returns to its idle state.
        const modal = this._infoModal;
        if (!modal.targetNode || !modal.targetNode.classList.contains('icon-sound')) return;
        this._restoreSoundPosition(poiBodyNode);
        const onStop = () => {
            if (this._infoModal !== modal || this._poiAsyncAction) return;
            modal.close({ silent: true });
        };
        poiBodyNode.querySelectorAll('audio, video').forEach(el => {
            el.addEventListener('pause', onStop);
            el.addEventListener('ended', onStop);
        });
    }

    // A sound label's HTML is re-fetched on every open, so its
    // <audio autoplay> is a new element each time. Remember where it was
    // paused (per src) so the next open resumes instead of restarting.
    _soundKey(el) {
        const source = el.querySelector('source');
        return el.currentSrc || el.src || (source && source.src) || '';
    }

    _rememberSoundPosition() {
        const modal = this._infoModal;
        if (!modal || !modal.container || !modal.targetNode) return;
        if (!modal.targetNode.classList.contains('icon-sound')) return;
        if (!this._soundPositions) this._soundPositions = new Map();
        modal.container.querySelectorAll('audio').forEach(el => {
            const key = this._soundKey(el);
            if (!key) return;
            if (el.ended || !el.currentTime) this._soundPositions.delete(key);
            else this._soundPositions.set(key, el.currentTime);
        });
    }

    _restoreSoundPosition(root) {
        if (!this._soundPositions || !this._soundPositions.size) return;
        root.querySelectorAll('audio').forEach(el => {
            const seek = () => {
                const t = this._soundPositions.get(this._soundKey(el));
                if (t && (!el.duration || t < el.duration)) el.currentTime = t;
            };
            if (el.readyState >= 1) seek();
            else el.addEventListener('loadedmetadata', seek, { once: true });
        });
    }

    parseInfoContainer(html, lang=this._countryCode) {
        lang = this.prepareLang(lang);
        if(this.isJSON(html)) {
            const obj = JSON.parse(html);
            html = obj[lang.toUpperCase()] || obj['EN'];

            if(Object.keys(obj).length === 1) {
                html = obj[Object.keys(obj)[0]];
            }
        }

        return html;
    }

    prepareLang(lang) {
        return lang.split('-')[0].toUpperCase();
    }

    isJSON(str) {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    }

    _focusHotspot(htmlURL, panelContainer) {
        if (!this._infoModal) return;

        const currentScene = this.viewer.getScene().toString();
        let scene = this.config.scenes.find((s) => s.id === currentScene);
        const hotspot = scene.hotspots.find((poi) => poi.htmlURL === htmlURL);
        if (!hotspot) return;

        const yaw = +hotspot.yaw;
        const pitch = +hotspot.pitch;
        const currentYaw = this.viewer.getYaw();
        const currentPitch = this.viewer.getPitch();

        if (currentYaw !== yaw) this.viewer.setYaw(yaw, 1000);
        if (currentPitch !== pitch) this.viewer.setPitch(pitch, 1000);
    }

    _getInfoPoi(htmlUrl) {
        return new Promise(async (res,rej) => {
           try {
            this._htmlUrl = htmlUrl;
            const html = await this._helperService.ajaxCall(htmlUrl);

            res(html.replace(/<p><br><\/p>$/img, ''));
           } catch(e) {
            rej(e)
           }
        })
    }

    _showInfoModalLoader(show = false) {
        let loaderNode = this._infoModal.container.querySelector(this._infoModal.loaderClassName);
        if (!loaderNode) return;
        let func = show ? 'add' : 'remove';
        loaderNode.classList[func]('show-loader');
        this._infoModal.loading = show;
    }

    _initInfoWrapper(container) {
        const draggingThreshold = 4;
        let wrapper = require('./pannellum-poi-editor/poi-viewer.html');

        container.innerHTML = wrapper;

        this._infoModal.infoContainer = container.querySelector('.e3-viewer-poi-info-frame');
        
        this._infoModal.readMore = {
            open: this._infoModal.infoContainer.querySelector('.e3-viewer-poi-info-frame-more'),
            close: this._infoModal.infoContainer.querySelector('.ql-close'),
            closeCallback: async (e) => {
                e.preventDefault();
                e.stopPropagation();
                this._fireEvent('close.fullscreen.info')

                // this.e3Sidebar.hide();
            },
            openCallback: async (e) => {
                e.preventDefault();
                e.stopPropagation();
                this._fireEvent('open.fullscreen.info')

                await this.e3Sidebar.append(this._htmlUrl);
                this.e3Sidebar.show();
                this._infoModal?.closeHandler();
                this._fireEvent('info-more-open');
            },
            hide: () => {
                this._infoModal.infoContainer.querySelector('.e3-viewer-poi-info-frame-more').classList.add('hidden');
            },
            show: () => {
                
                this._infoModal.infoContainer.querySelector('.e3-viewer-poi-info-frame-more').classList.remove('hidden');
            }
        }

        this._infoModal.stopPropagation = e => e.stopPropagation();
        this._infoModal.closeHandler = () => this._infoModal.close();
        // silent: close without 'info-close-handler', so narration is not
        // resumed (used when another media source took over the audio).
        this._infoModal.close = ({ silent = false } = {}) => {
            // this.container.removeEventListener('mousemove', this._infoModal.removeCancelEventListener, {capture: true, once: true});
            this.container.removeEventListener('mousemove', this._infoModal.removeCancelEventListener, false);
            this.container.removeEventListener('touchmove', this._infoModal.removeCancelEventListener, {
                capture: false,
                once: true,
                passive: true
            })
            this.container.removeEventListener('click', this._infoModal.closeHandler, false);
            this._infoModal.targetNode.classList.remove(`pnlm-info-${(this._infoModal.size)}`);
            if (this._infoModal.closeButton) this._infoModal.closeButton.removeEventListener('click', this._infoModal.closeHandler);

            if (this._infoModal.size === 'fullscreen') {
                this.clearIconFullScreenMode();
                if(this._agentCall) {
                    this._agentCall.showAgentBubble();
                }
                if (this._e3plan3DPreview) this._e3plan3DPreview.show();
            }

            this._resolvePendingInfo();
            this._poiAsyncAction = this._hideInfo();
            if (!silent) this._fireEvent('info-close-handler');
        };

        // disables 'click' handler from container during scene panning
        this._infoModal.removeCancelEventListener = (e) => {
            this._infoModal.dragging.x += e.movementX;
            this._infoModal.dragging.y += e.movementY;

            let {x, y} = this._infoModal.dragging;

            if (Math.abs(x) > draggingThreshold || Math.abs(y) > draggingThreshold) {
                this.container.removeEventListener('click', this._infoModal.closeHandler, false);
                this.container.removeEventListener('mousemove', this._infoModal.removeCancelEventListener, false);

                delete this._infoModal.dragging;
            }
        };

        // add mousedown listener for handling outbox click
        this._infoModal.onOutboxClick = () => {
            this._fireEvent('close.info')
            this._infoModal.dragging = {x: 0, y: 0};
            this.container.addEventListener('mousemove', this._infoModal.removeCancelEventListener, false);
            this.container.addEventListener('touchmove', this._infoModal.removeCancelEventListener, {
                capture: false,
                once: true,
                passive: true
            });
            this.container.addEventListener('click', this._infoModal.closeHandler, false);
            // this.container.addEventListener('click', this.e3Sidebar.hide.bind(this.e3Sidebar), false);
        };

        this.container.addEventListener('mousedown', this._infoModal.onOutboxClick);
        this.container.addEventListener('touchstart', this._infoModal.onOutboxClick);

        this._infoModal.infoContainer.addEventListener('click', this._infoModal.stopPropagation, false);
        this._infoModal.infoContainer.addEventListener('mousewheel', this._infoModal.stopPropagation, false);
        this._infoModal.readMore.open.addEventListener('click', this._infoModal.readMore.openCallback, false);
        this._infoModal.readMore.close.addEventListener('click', this._infoModal.readMore.closeCallback, false);

        // Firefox scrolling event
        this._infoModal.infoContainer.addEventListener('DOMMouseScroll', this._infoModal.stopPropagation, false);

        this._infoModal.contentClass = 'e3-viewer-poi-info-frame-wrapper';
        this._infoModal.type = 'viewer';
    }

    iconFullScreenMode() {
        const tollbar = this._infoModal.toolbar;
        const closeButton = this._infoModal.closeButton

        tollbar.classList.remove('hidden');
        closeButton.classList.remove('hidden');

        this.hideLogo();
    }

    clearIconFullScreenMode() {
        const tollbar = this._infoModal.toolbar;
        const closeButton = this._infoModal.closeButton

        tollbar.classList.add('hidden');
        closeButton.classList.add('hidden');

        this.showLogo();
    }

    showLogo() {
        const logo = document.querySelector('.company-logo');
        logo && logo.classList.remove('hidden');
    }

    hideLogo() {
        const logo = document.querySelector('.company-logo');
        logo && logo.classList.add('hidden');
    }

    _addInfoImagePreviewNode(infoModal, container) {
        const node = require('./pannellum-poi-editor/poi-image-preview.html');
        let imagePreviewWrapper = document.createElement('div');

        imagePreviewWrapper.classList.add('e3-viewer-poi-info-fullscreen');
        imagePreviewWrapper.innerHTML = node;

        infoModal.imagePreview = {
            container: imagePreviewWrapper,
            closeBtn: imagePreviewWrapper.querySelector('.close-fullscr-img'),
            closeHandler: (e) => {
                e.stopPropagation();

                if (e.target.nodeName.toLowerCase() === 'img') return;

                // todo: do we need this?
                if (this._player && this._player.isPlaying()) {
                    this._onE3PlayPause(true);
                }
                this._closeFullScreenImage();
            },
            showHandler: this._showFullScreenImage.bind(this),
        };

        container.appendChild(imagePreviewWrapper);

        // infoModal.imagePreview.closeBtn.addEventListener('click', infoModal.imagePreview.closeHandler, true);
        imagePreviewWrapper.addEventListener('click', infoModal.imagePreview.closeHandler);

        return infoModal;
    }

    _destroyInfoImagePreview(infoModal, container) {
        if (!infoModal.imagePreview) return infoModal;

        let list = infoModal.container.querySelectorAll('img');

        if (list.length)
            Array.from(list).forEach(image => this._unsetInfoImageHandlers(image));

        infoModal.container.removeEventListener('click', infoModal.imagePreview.closeHandler);
        container.removeChild(infoModal.imagePreview.container);

        return infoModal;
    }

    _initFullScreenPreview() {
        let list = this._infoModal.container.querySelectorAll('img');

        if (!list.length) return;

        this._addInfoImagePreviewNode(this._infoModal, this.container);

        Array.from(list).forEach(image => this._setInfoImageHandlers(image));
    }

    _unsetInfoImageHandlers(imageWrapper) {

    }

    _setInfoImageHandlers(img) {
        img.removeEventListener('click', this._infoModal.imagePreview.showHandler, true);
        if (img) {
            img.onload = function (element) {
                element.addEventListener('click', this._infoModal.imagePreview.showHandler, true);
                element.classList.remove('hide-full-screen');
            }.bind(this, img);
        }
    }

    _closeFullScreenImage() {
        this._infoModal.imagePreview.container.classList.remove('show');
    }

    _showFullScreenImage(e) {
        e.stopImmediatePropagation();
        var img = e.target.tagName !== 'DIV' ? e.target : e.target.querySelector('img');
        var src = img ? img.src : null;
        if (!src) return;
        this._infoModal.imagePreview.container.querySelector('img').src = src;
        this._infoModal.imagePreview.container.classList.add('show');
    }

    destroyInfoModal() {
        if (!this._infoModal) return;
        this._rememberSoundPosition();
        if (this._infoModal._detachMedia) this._infoModal._detachMedia();
        this._infoModal.infoContainer.removeEventListener('click', this._infoModal.stopPropagation, false);
        this._infoModal.infoContainer.removeEventListener('mousewheel', this._infoModal.stopPropagation, false);
        this._infoModal.infoContainer.removeEventListener('DOMMouseScroll', this._infoModal.stopPropagation, false);

        this.container.removeEventListener('mousedown', this._infoModal.onOutboxClick);
        this.container.removeEventListener('touchstart', this._infoModal.onOutboxClick);

        // if (this._infoModalHidden) {
        //     this._infoModalHidden = false;
        //     this.container.removeEventListener('mousemove', this._infoModal.removeCancelEventListener, {capture: true, once: true});
        //     this.container.removeEventListener('click', this._infoModal.closeHandler, {capture: false, once: true});
        // }

        // this.container.removeEventListener('mousemove', this._infoModal.removeCancelEventListener, {capture: true, once: true});
        this.container.removeEventListener('mousemove', this._infoModal.removeCancelEventListener, false);
        this.container.removeEventListener('touchmove', this._infoModal.removeCancelEventListener, {
            capture: true,
            once: true
        });
        // this.container.removeEventListener('click', this._infoModal.closeHandler, {capture: false, once: true});
        this.container.removeEventListener('click', this._infoModal.closeHandler, false);

        this._infoModal.container.parentNode.removeChild(this._infoModal.container);
        this._destroyInfoImagePreview(this._infoModal, this.container);
        // this._unsetInfoImageHandlers(this._infoModal);
        this._destroyMsgListener()

        delete this._poiAsyncAction;
        delete this._infoModal;
    }

    _setCookie(name, value, options) {
        options = options || {};

        var expires = options.expires;

        if (typeof expires == "number" && expires) {
            var d = new Date();
            d.setTime(d.getTime() + expires * 1000);
            expires = options.expires = d;
        }
        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString();
        }
        value = encodeURIComponent(value);
        var updatedCookie = name + "=" + value;
        for (var propName in options) {
            updatedCookie += "; " + propName;
            var propValue = options[propName];
            if (propValue !== true) {
                updatedCookie += "=" + propValue;
            }
        }

        document.cookie = updatedCookie;
    }

    _getCookie(name) {
        var matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    _deleteCookie(name) {
        this._setCookie(name, "", {
            expires: -1
        })
    }

    parse_url(url) {
        var vars = url.split("&");
        var url_string = {};
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (typeof url_string[pair[0]] === "undefined") {
                url_string[pair[0]] = decodeURIComponent(pair[1]);
            } else if (typeof url_string[pair[0]] === "string") {
                var arr = [url_string[pair[0]], decodeURIComponent(pair[1])];
                url_string[pair[0]] = arr;
            } else {
                url_string[pair[0]].push(decodeURIComponent(pair[1]));
            }
        }
        return url_string;
    }

    /***
     * Detect iOS Facebook app embedded browser
     * and recalculate body height according to width height
     * (specific iOS FB embedded browser issue)
     */
    _fixViewportHeight() {
        if (!(navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/FBAV/i))) return;

        var html = document.querySelector('html');
        var _recalculatePageHeight = function (delay) {
            setTimeout(function () {
                html.style.height = window.innerHeight + 'px'
            }, delay || 4);
        };

        this._panel._panel.addEventListener('touchmove', function (e) {
            e.preventDefault()
        });

        if (this._companyLogo) {
            this._companyLogo.addEventListener('touchmove', function (e) {
                e.preventDefault()
            });
        }

        window.addEventListener('orientationchange', function () {
            _recalculatePageHeight(500)
        });

        _recalculatePageHeight(500);
    }

    _checkIfVRAvailable() {
        return this._translationPromise.then(() => {
            if (this._isFBapp) {
                var message = this._is_iOS ? this._modalService.prepareVWMessage('ios_fb') : this._modalService.prepareVWMessage('android_fb');
                this._modalService.showCreatedModal('alert', message, true);

                return;
            } else if (this._isWebView) {
                this._modalService.showCreatedModal('alert', this._modalService.prepareVWMessage('android_wv'), true);

                return;
            } else if (this._isIosWebView) {
                this._modalService.showCreatedModal('alert', this._modalService.prepareVWMessage('ios_wv'), true);

                return;
            } else if (this._is_iOS && this._isIosMotionDisabled) {
                this._modalService.showCreatedModal('alert', this._modalService.prepareVWMessage('ios_motion', ''), true);

                return;
            } else {
                return true;
            }
        });
    }

    _checkIfLiveAvailable() {
        return this._translationPromise.then(() => {
            if (this._isIosChrome) {
                // this._modalService.showCreatedModal('alert', this._translateService.translate('E3_LIVE_IOS_CHROME_ERROR_DESCR'), true);
                var template = '<p>' + this._translateService.translate('E3_LIVE_IOS_CHROME_ERROR_DESCR') + '</p>' +
                    '<div id="copy" class="inviteUrl"><input type="text" class="copy-url" value="' + this._location.href + '"/><span class="copy copy-icon"></span></div>';
                this._modalService.showCreatedModal('alert', template, true, {
                    'copy': {
                        event: 'click',
                        handler: this._helperService.copyToClipboard.bind(null, 'e3-viewer-modal', 'copy', this._location.href)
                    }
                });

                return;
            } else if (this._isOperaMini) {
                var template = '<p>' + this._translateService.translate('USE_ONE_OF_THESE_BROWSER') + '</p><p><table style="margin-left:auto; margin-right:auto"> <tbody><tr class="browsers"> <th><img src="https://www.eyespy360.com/common/images/browser_logos/chrome.png" alt="Chrome" title="Chrome"></th> <th><img src="https://www.eyespy360.com/common/images/browser_logos/firefox.png" alt="Mozilla Firefox" title="Mozilla Firefox"></th> <th><img src="https://www.eyespy360.com/common/images/browser_logos/edge.png" alt="Edge" title="Edge"></th> <th><img src="https://www.eyespy360.com/common/images/browser_logos/safari.png" alt="Safary" title="Safary"></th> </tr><tr class="versions"> <th>Chrome 60</th> <th>Firefox 55</th> <th>Edge 40</th> <th>Safari 11</th> </tr></tbody></table></p>';
                this._modalService.showCreatedModal('alert', template, true);

                return;
            } else if (this._isFBapp) {
                var message = this._is_iOS ? this._modalService.prepareVWMessage('ios_fb', 'e3live') : this._modalService.prepareVWMessage('android_fb', 'e3live');
                this._modalService.showCreatedModal('alert', message, true);

                return;
            } else if (this._isWebView) {
                this._modalService.showCreatedModal('alert', this._modalService.prepareVWMessage('android_wv', 'e3live'), true);

                return;
            } else if (this._isIosWebView) {
                this._modalService.showCreatedModal('alert', this._modalService.prepareVWMessage('ios_wv', 'e3live'), true);

                return;
            } else {
                return true;
            }
        });
    }

    enableListening() {
        this.viewer.enableStateListening();
        let callback = eventName => this._fireEvent.bind(this, eventName);
        this.viewer.on('statechange', callback('statechange'));
        this.viewer.on('statechange-start', callback('statechange-start'));
        this.viewer.on('statechange-end', callback('statechange-end'));

        if (this._player) this._onE3PlayExit();
        this._panel.disableControl('e3-player.start');
    }

    disableListening() {
        this.viewer.off('statechange');
        this.viewer.off('statechange-start');
        this.viewer.off('statechange-end');
        this.viewer.disableStateListening();
        this._panel.enableControl('e3-player.start');
    }


    onE3PlayStart() {
        this._onE3PlayStart();
    }

    _onE3PlayStart() {
        this._fireEvent('on-e3-play-start', true);
        // e3play's own media drives the camera and is not coordinated; just
        // silence whatever else is playing.
        this._mediaService.pauseAll();
        let configs = cloneDeep(this.config);

        if (this._e3plan3D && !this._e3plan3D.isHidden()) {
            this._on3DPlanClick({view2D: false});
        }

        if (this._e3plan3DPreview) {
            this._e3plan3DPreview.hide();
        }

        if (!configs.e3play) return;

        if (this._orientationHelper) {
            this._orientationHelper.hide();
        }

        this._noSleep.enable();
        this.container.classList.add('e3-player-mode');
        this._protobufService.parseDat(configs.e3play.commands).then(obj => {
            configs.e3play.commands = obj.commands;
            this.viewer.setMode('e3play');
            if(!configs.e3play.audio) {
                this.viewer.setMode('e3autovideo');
            }
            //initializing player service with audio src and command. To work with it further need to wait for audioReady promise
            this._player = new PlayerService({
                audio: configs.e3play.audio,
                video: configs.e3play.video,
                commands: configs.e3play.commands,
            }, this._is_iOS, this.container);
            this._onE3PlayInterrupt = this._onE3PlayInterrupted.bind(this);
            //showing player controls
            this._panel.enableE3PlayMode();
            this._panel.disablePlay();
            this._player.audioReady.catch(() => {
                this._translationPromise.then(() => {
                    this._modalService.showCreatedModal('e3play.error.audio', this._translateService.translate('AUDIO_ERROR'), true, {
                        'chat-modal-close': () => {
                            this._onE3PlayExit();
                            return true;
                        }
                    });
                });
            });
            this._player.on('loadedmetadata', playerState => {
                this._panel.setDuration(this._player.getAudioDuration());
                this._player.setVolume(this._panel.getVolume());
                //waiting until can play audio and setting current state
                this._sceneChanging.promise
                    .then(
                        function () {
                            return Promise.all([this._onE3PlayStateChange(playerState), this._player.audioReady])
                        }.bind(this)
                    ).then(function () {
                    //enabling controls when state has been set
                    this._panel.enablePlay();
                    this._onE3PlayPlay();
                }.bind(this))
                    .catch((e) => {
                        console.error(e);
                    });
            });
            this._player.on('statechange', this._onE3PlayStateChange.bind(this));
            // this._player.on('waiting', this._onE3PlayWaiting.bind(this));
            this._player.on('playing', time => {
                this.viewer.stopAnimation();
                this._onE3PlayPlaying(time);
                this._startTime = new Date().getTime();
                this._sendAnalitics({hitType: 'event', eventCategory: 'e3play', eventAction: 'e3play_start'});
            });
            this._player.on('pause', time => {
                this._onE3PlayPaused(time);
                if (time !== 0) this._sendAnalitics({
                    hitType: 'event',
                    eventCategory: 'e3play',
                    eventAction: 'e3play_end'
                });
            });
            this._player.on('buffer.change', this._panel.setBuffer.bind(this._panel));
            this._showleadGenTimeChange = true;
            this._player.on('ended', () => {
                this._sendAnalitics({hitType: 'event', eventCategory: 'e3play', eventAction: 'e3play_end'});
                this.viewer.e3PlayEvent('end');
                this._onE3PlayPause(true);
                this._noSleep.disable();
                this._onE3PlayExit();
                if(this.isShowLeadGen && this._showleadGenTimeChange) {
                    this._leadGenAgentAnswer();
                }
                // this._panel.pause.bind(this._panel, 0, false, true);
            });
            this._player.on('timechange', (currentTime, playing) => {
                if(this.isShowLeadGen && this._showleadGenTimeChange && currentTime > 60) {
                    this._player.pause();
                    this._leadGenAgentAnswer()
                        .then(() => {
                            this._player.play(true);
                        })
                        .catch(() => {
                            this._player.play(true);
                        });
                    this._showleadGenTimeChange = !this._showleadGenTimeChange;
                }
                this._panel.setTime(currentTime, false, true, playing);
            });
            this._player.on('muted', () => this._panel.setVolume(0));
            this.viewer.on('orientation', this._onE3PlayInterrupt);
        })
    }

    _onE3PlayExit() {
        this.container.classList.remove('e3-player-mode');
        //destroying audio tag from memory, listeners, timeouts for commands etc
        this.viewer.off('orientation', this._onE3PlayInterrupt);
        this._toggleE3PlayLoader(false);
        // this._player.clearInterrupted();
        this._panel.disableE3PlayMode();
        if (this._player) {
            this._player.destroy();
            this._player = null;
        }
        this._noSleep.disable();

        if (this._e3plan3DPreview) {
            this._e3plan3DPreview.show({view2D: true});
        }

        this.viewer.setMode('view');
        this._fireEvent('on-e3-play-exit');
    }

    _onE3PlayPlay(e) {
        if (e) this._noSleep.enable();
        this._panel.hidePanel();
        this._onE3PlayPrePlay()
            .then(() => {
                // start playing audio, no need to change state for current time
                // (it is done when changing timeline value, just after it. Look into timechange event on panel controls)
                this._player.play(true);
                this._noSleep.enable();

                //hiding panel on mouse idling
                if (!this._onMouseMoveBound) {
                    this._onMouseMoveBound = this._onMouseMove.bind(this);
                    this.container.addEventListener('mousemove', this._onMouseMoveBound);
                    this.container.addEventListener('touchstart', this._onMouseMoveBound);
                }
            });
    }

    _onE3PlayPrePlay() {
        return this._onE3PlayStateChange(this._player.getInterrupted())
            .then(this._player.clearInterrupted.bind(this._player))
            .catch(function (err) {
                console.error(err);
                this._noSleep.disable()
            });
    }

    _onE3PlayStateChange(state) {
        if (!state) return Promise.resolve();
        //returning promise of changing state (async operation)
        return new Promise((resolve) => {
            if (state.scene.toString() !== this.viewer.getScene().toString()) {
                this._onE3PlayPauseLoader(state.animation.duration * 1000, true);
                this.viewer.loadScene(
                    state.scene,
                    state.pitch,
                    state.yaw,
                    state.hfov,
                    this._onE3PlayResumeLoader.bind(this, resolve)
                );
                return;
            }
            this.viewer.lookAt(
                state.pitch,
                state.yaw,
                state.hfov,
                state.animation.duration * 1000,
                resolve
            );
            if (!state.animation.duration) {
                resolve();
            }
        });
    }

    _onE3PlayPauseLoader(timeoutTime, showLoader) {
        this._e3Timeout.set(() => {
            if (this._player) this._player.pause();
            if (showLoader) this._toggleE3PlayLoader(true);
        }, timeoutTime);
    }

    _onE3PlayResumeLoader(resolve) {
        this._e3Timeout.reset();
        if (this._player && this._player.isPlaying()) {
            this._player.play();
        }
        this._toggleE3PlayLoader(false);
        resolve();
    }

    _toggleE3PlayLoader(add) {
        if (!this._loader) {
            if (!add) {
                return;
            }
            let wrapper = document.createElement('div');
            wrapper.classList.add('e3play-loader');
            wrapper.id = 'e3play-loader';
            wrapper.innerHTML = '<div class="e3play-loader-box"><div class="e3play-loader-animation"></div></div>';
            this.panorama.appendChild(wrapper);
            this._loader = wrapper;
        }
        this._loader.style.display = add ? '' : 'none';
    }

    _onE3PlayWaiting(time) {
        if (this._player.isPlaying()) {
            this._panel.pause(time);
            this._toggleE3PlayLoader(true);
            this.viewer.lookAt(this.viewer.getPitch(), this.viewer.getYaw(), this.viewer.getHfov(), 1);
        }
    }

    _onE3PlayPlaying(time) {
        this._toggleE3PlayLoader(false);
        //toggle play button
        this._panel.play(time);
        if (this._modalService.checkIfModalPresent('alert.play')) this._modalService.close('alert.play');
    }

    //audio pause event
    _onE3PlayPaused(time) {
        this._panel.pause(time);
    }

    _onE3PlayPause(isUserInteraction) {
        //stop playing audio
        if (!this._player) return;
        this._player.pause(true);
        this._noSleep.disable();

        //stop on current frame
        if (isUserInteraction !== true) { // isUserInteraction can be mouse event emitted by pause button click
            this.viewer.lookAt(this.viewer.getPitch(), this.viewer.getYaw(), this.viewer.getHfov(), 1);
        }

        if (this._onMouseMoveBound) {
            this.container.removeEventListener('mousemove', this._onMouseMoveBound);
            this.container.removeEventListener('touchstart', this._onMouseMoveBound);
            this._onMouseMoveBound = null;
        }
    }

    _onE3PlayTimeChangeStart() {
        if (this._player && this._panel.isE3PlayModeEnabled()) {
            this._onE3PlayPause(true);
        }
    }

    _onE3PlayTimeChange(currentTime) {
        this._toggleE3PlayLoader(false);
        if (this._player && this._panel.isE3PlayModeEnabled()) {
            // this._player.pause(true);
            // this._onE3PlayPause(true);
            var state = this._player.setTime(currentTime);
            state.animation ? state.animation.duration = 0 : state.animation = {duration: 0};
            this._panel.disablePlay();
            this._onE3PlayStateChange(state).then(() => {
                if (this._player.isAudioReady) this._panel.enablePlay();
            });
        }
    }

    _onE3PlayTimeChangeEnd() {
        if (this._player && this._panel.isE3PlayModeEnabled()) {
            this._onE3PlayPlay(true);
        }
    }

    _onE3PlayVolumeChange(volume) {
        this._player.setVolume(volume)
    }

    _onE3PlayInterrupted() {
        if (this._player.getInterrupted()) return;
        let state = {
            scene: this.viewer.getScene(),
            pitch: this.viewer.getPitch(),
            yaw: this.viewer.getYaw(),
            hfov: this.viewer.getHfov(),
            type: 'coord',
            animation: {duration: 0}
        };
        this._player.setInterrupted(state);
        this._onE3PlayPause(true);
    }

    _onMouseMove() {
        this.container.classList.remove('mouseidling');
        //hide player controls on mouse idling
        if (this._mouseMoveTimeout) clearTimeout(this._mouseMoveTimeout);
        this._mouseMoveTimeout = setTimeout(() => {
            this.container.classList.add('mouseidling');
        }, 4000);
    }

    _initOrientationHelper() {
        if(!this._intro_mouse_icon) return;
        if (this._orientationHelper) return;

        let opt = this._isTouchDevice ? {type: 'hand'} : {type: 'mouse'};
        this._orientationHelper = new OrientationHelper(this.pannellumContainer, {...opt, accessibility: this._accessibility});

        this._orientationHelper.play();
        // this._orientationHelperHide = this._orientationHelper.hide.bind(this._orientationHelper);
        this._orientationHelperHide = this._orientationHelper.hide.bind(this._orientationHelper);
        this.container.addEventListener('mousedown', this._orientationHelperHide, {capture: true, once: true});
        this.container.addEventListener('touchstart', this._orientationHelperHide, {capture: true, once: true});
    }

    _hideOrientationHelper() {
        this._orientationHelperHide();
    }

    _onE3TourInfo({resolve, reject}) {
        let url = this.config.infoURL;

        this._panel.resetControlsButtonsActiveState();

        this._helperService.ajaxCall(url)
            .then((res) => resolve(res))
            .catch((error) => reject(error));
    }

    _findActiveFloorplan(markers, sceneId) {
        var i;
        if (!sceneId) {
            return null;
        }
        for (i = 0; i < markers.length; i++) {
            if (markers[i].imageID == sceneId) {
                return markers[i].floorplanID;
            }
        }
        return null;
    }

    _initE3Plan3D() {
        if (!this.e3plan_json || !this.e3plan_json.preview || !this.permissions['t_3d_model']) return;
        let {offsetWidth: width, offsetHeight: height} = this.e3plan3DContainer;
        this._e3plan3D = new E3Plan3D(this.e3plan3DContainer, this.e3plan_json.preview, {
            width,
            height,
            t_3d_model_dimensions: this.permissions['t_3d_model_dimensions']
        });

        this._e3plan3D.on('scene.change.start', this._onE3Plan3DSceneChangeStart.bind(this));
        this._e3plan3D.on('scene.change.end', this._onE3Plan3DSceneChangeEnd.bind(this));
        this._e3plan3D.on('scene.get.current', this._onE3Plan3DSceneGetCurrent.bind(this));
        this._e3plan3D.on('model.hidden', this._panel.resetControlsButtonsActiveState.bind(this._panel));

        if (!this.config.editable) {
            if((this._is_iOS && this._nomini3donmobile) || (this._isAndroid && this._nomini3donmobile) || this._urlParams.converte3video) return false;
            if(this._urlParams.mini_floorplan === 'true') return ;

            this._initE3Plan3DPreview();
        }
    }

    _getFloorplanWithPreview(){
        const {editable} = this.config;

        return editable ? this.viewer.getFloorplanWithPreview() : this.e3plan_json;
    }

    _initE3Plan2DPreview() {
        const {markers, editable, floorplans} = this.config;

        this.e3plan2DPreviewContainer = document.createElement('div');
        this.e3plan2DPreviewContainer.classList.add('e3-viewer-2dplan-mini');

        const closeClassName = 'e3-viewer-2dplan-mini__close';
        let closeBtnClass = this._isTouchDevice ? [] : [`${closeClassName}--hover`];

        this.container.appendChild(this.e3plan2DPreviewContainer);
        const sceneID = this.viewer.getScene();

        this._e3plan2DPreview = new E3Plan2D(this.e3plan2DPreviewContainer, this._getFloorplanWithPreview(), {
            width: PREVIEW_SIZE.width,
            height: PREVIEW_SIZE.height,
            editable,
            previewMode: true,
            closeBtnClass: [closeClassName, ...closeBtnClass],
            sceneID,
            permissions: this.permissions
        });

        this._e3plan2DPreview.init(floorplans, markers);
        const events = [
            {
                name: 'read',
                func: () => {
                    let yaw = this.viewer.getYaw();
                    this._e3plan2DPreview.updateTeleportFOV(yaw);
                }
            },
            {
                name: 'destroy',
                func: () => this.container.removeChild(this.e3plan2DPreviewContainer)
            },
            {
                name: 'click',
                func: () => this.container.querySelector('.control-floorplans_2d').click()
            },
            {
                name: 'scenes.select',
                func: this._onSelectStart.bind(this)
            }
        ];

        events.forEach(({name, func}) => this._e3plan2DPreview.on(name, func));

        this.viewer.on('scenechange', (sceneID) => {
            this._e3plan2DPreview.selectRasterPlan(sceneID);
        });

        this.viewer.on('viewer-orientation-change', (event) => {
            let {yaw} = event;
            this._e3plan2DPreview.updateTeleportFOV(yaw);
            // this._onStayAction();
        });
    }

    _initVrview(){
        this.vrviewContainer = document.createElement('div');
        this.vrviewContainer.classList.add('e3-viewer-vr');
        this.vrviewContainer.classList.add('e3-hidden');
        this.vrviewContainer.id = 'e3-viewer-vrview';
        this.container.appendChild(this.vrviewContainer);
    }

    _initE3PlanPreview() {
        this.e3plan3DContainer = document.createElement('div');
        this.e3plan3DContainer.classList.add('e3-viewer-3dplan');
        this.e3plan3DPreviewContainer = document.createElement('div');
        this.e3plan3DPreviewContainer.classList.add('e3-viewer-3dplan-mini');
        this.container.appendChild(this.e3plan3DContainer);
    }

    _showE3PlanPreview() {
        this.e3plan3DPreviewContainer.classList.remove('hidden');
        this.e3plan2DPreviewContainer.classList.remove('hidden');
    }

    _hideE3PlanPreview() {
        this.e3plan3DPreviewContainer.classList.add('hidden');
        this.e3plan2DPreviewContainer.classList.add('hidden');
    }

    _initE3Plan3DPreview = async () => {
        const closeClassName = 'e3-viewer-3dplan-mini__close';
        let closeBtnClass = this._isTouchDevice ? [] : [`${closeClassName}--hover`];

        this.container.appendChild(this.e3plan3DPreviewContainer);

        this._e3plan3DPreview = new E3Plan3D(this.e3plan3DPreviewContainer, this.e3plan_json.preview, {
            width: PREVIEW_SIZE.width,
            height: PREVIEW_SIZE.height,
            previewMode: true,
            fitCanvasToModel: true,
            closeBtnClass: [closeClassName, ...closeBtnClass]
        });

        this._on3DPlanMouseDownPreviewBound = (e) => {
            this._handleFirstClick = !this._e3plan3DPreview.isView2D();

            if (this._handleFirstClick) {
                e.stopPropagation();
                this.container.removeEventListener('mousedown', this._onActionStartBound, {capture: false, once: true});
                this.container.removeEventListener('touchstart', this._onActionStartBound, {
                    capture: false,
                    once: true
                });
            }
        };

        this._on3DPlanClickPreviewBound = () => {
            const view2D = !this._handleFirstClick,
                autoRotate = this._e3plan3DPreview.isAutoRotateEnabled(),
                view2DPosition = view2D ? this._e3plan3DPreview.getView2DPosition() : null;

            this._toogleE3PanelSync();
            this._on3DPlanClick({view2D, autoRotate, view2DPosition});

            if (this._handleFirstClick) {
                this._e3plan3DPreview.stopAutoRotate();
            }
        };

        this._onActionStartBound = this._onContainerActionStart.bind(this);
        const waitingPreview = Deffer();
        const onFirstAction =  async () => {
            await waitingPreview.promise;
            await this._e3plan3DPreview.isReady();
            this._onActionStartBound();
        }

        this._e3plan3D.on('model.hidden', () => {
            if (this._handleFirstClick) {
                // this._e3plan3DPreview.moveTo3DView();
                this._e3plan3DPreview.startAutoRotate();
                this.container.addEventListener('mousedown', onFirstAction, {
                    capture: false,
                    once: true
                })}
                this.container.addEventListener('touchstart', onFirstAction, {
                    capture: false,
                    once: true
                })
        });
        this.e3plan3DPreviewContainer.addEventListener('mousedown', this._on3DPlanMouseDownPreviewBound, {capture: true});
        this.e3plan3DPreviewContainer.addEventListener('touchstart', this._on3DPlanMouseDownPreviewBound, {capture: true});
        this.e3plan3DPreviewContainer.addEventListener('click', this._on3DPlanClickPreviewBound);
        this.container.addEventListener('mousedown', onFirstAction, {capture: false, once: true});
        this.container.addEventListener('touchstart', onFirstAction, {capture: false, once: true});

         // this._onStayAction();

         this.viewer.on('viewer-orientation-change', (event) => {
            let {yaw} = event;
            this._e3plan3DPreview.updateTeleportFOV(yaw);
            // this._onStayAction();
        });
       
        this._e3plan3DPreview.on('scene.get.current', this._onE3Plan3DSceneGetCurrent.bind(this));
        this._e3plan3DPreview.on('model.hidden', () => {
            this._handleFirstClick = false;
            this._e3plan3DPreview.moveTo2DView(this.viewer.getScene());
        });

        await this._e3plan3DPreview.parseTextures();
        await this._e3plan3DPreview.init(false);

        if (!this._autoE3play) {
            await this._e3plan3DPreview.show();
        }

        waitingPreview.resolve();
    }

    _onContainerActionStart(e, sceneID = this.viewer.getScene()) {
        if(this._e3plan3DPreview) this._e3plan3DPreview.moveTo2DView(sceneID);

        this.container.removeEventListener('mousedown', this._onActionStartBound, {capture: false, once: true});
        this.container.removeEventListener('touchstart', this._onActionStartBound, {capture: false, once: true});
    }

    _onE3Plan3DSceneChangeStart(e) {
        let {sceneID, resolve, sync} = e;
        let currentScene = this.viewer.getScene().toString();

        this._fireEvent('on-e3plan3d-scene.change.start', sceneID);

        // todo: check if _onSceneChange() duplicate this logic
        if (this._e3plan3DPreview && !this._e3plan3DPreview.isView2D()) {
            this._onContainerActionStart(null, sceneID);
            // this._e3plan3DPreview.moveTo2DView(sceneID);
        }

        if (currentScene === sceneID) {
            let yaw = this.viewer.getYaw();
            let pitch = this.viewer.getPitch();
            let hfov = this.viewer.getHfov();

            resolve({yaw: yaw * Pannellum.RADIAN, pitch: pitch * Pannellum.RADIAN});
        } else {
            let scene = this.config.scenes.find((s) => s.id === currentScene);
            let hotspot = scene.hotspots.find((h) => h.link === sceneID);

            // in case if we're not in connected room
            if (!hotspot) {
                let promise = new Promise((_resolve, _reject) => {
                    this.viewer.loadScene(sceneID, 0, 0, 120, () => _resolve())
                });

                return resolve({yaw: 0, pitch: 0, promise});
            }

            let {targetYaw, yaw, targetPitch, pitch, targetHfov, hfov} = hotspot;

            targetYaw = Number(targetYaw);
            targetPitch = Number(targetPitch);
            targetHfov = Number(targetHfov);

            let promise = new Promise((_resolve, _reject) => {
                this.viewer.loadScene(sceneID, targetPitch, targetYaw, targetHfov, () => _resolve())
            });


            resolve({yaw: targetYaw * Pannellum.RADIAN, pitch: targetPitch * Pannellum.RADIAN, promise})
        }

        if(sync) this._moveSceneE3PanelSync(sceneID);
    }

    _onE3Plan3DSceneChangeEnd() {
        this._e3plan3D.hide();
        this._panel.resetControlsButtonsActiveState();
    }

    _onE3Plan3DSceneGetCurrent(e) {
        const {resolve} = e;
        const sceneID = this.viewer.getScene();
        const yaw = this.viewer.getYaw();
        const pitch = this.viewer.getPitch();
        const hfov = this.viewer.getHFov();

        resolve({hfov, sceneID, yaw, pitch});
    }

    _destroyE3Plan3D() {
        if (!this._e3plan3D) return;

        this._e3plan3D.off();
        this._e3plan3D.destroy();

        if (this._e3plan3DPreview) {
            this.e3plan3DPreviewContainer.removeEventListener('mousedown', this._on3DPlanMouseDownPreviewBound, {capture: true});
            this.e3plan3DPreviewContainer.removeEventListener('touchstart', this._on3DPlanMouseDownPreviewBound, {capture: true});
            this.e3plan3DPreviewContainer.removeEventListener('click', this._on3DPlanClickPreviewBound);

            this.container.removeEventListener('mousedown', this._onActionStartBound, {capture: false, once: true});
            this.container.removeEventListener('touchstart', this._onActionStartBound, {capture: false, once: true});

            this._e3plan3DPreview.off();
            this._e3plan3DPreview.destroy();
        }
    }

    _on3DPlanClickResetState(e) {
        if (!e) return;

        this._panel.closeContent();
        e.target.classList.add('active');
    }

    _on3DPlanClick(options, e) {
        // const promise = this._planPreviewMove2DPromise ? this._planPreviewMove2DPromise : Promise.resolve();
        if (options && options.view3D) this._panel.hidePanel();
        const view2D = options ? options.view2D || false : false;
        const autoRotate = options ? options.autoRotate || false : false;
        const view2DPosition = options ? options.view2DPosition || null : null;

        this._on3DPlanClickResetState(e);

        if (this._e3plan3DPreview && this._e3plan3DPreview.isHidden()) {
            this._e3plan3DPreview.show(true);
        }

        if (!this._e3plan3D.isInited() || this.isNeedUpdate3dTexture()) {
            if (!this._e3plan3D.isHidden()) {
                this._e3plan3D.hide();
            } else {
                this._e3plan3D.init(this.config.editable, false);
                this._e3plan3D.show(view2D, autoRotate, view2DPosition);
                this.setNeedUpdate3dTexture(false);
            }
        } else {
            if (!this._e3plan3D.isHidden() && e) {
                this._panel.resetControlsButtonsActiveState();
            }
            this._e3plan3D.toggleView(view2D, autoRotate, view2DPosition);
        }
    }

    isNeedUpdate3dTexture() {
        return this._isNeedUpdate3dTexture;
    }

    setNeedUpdate3dTexture(status) {
        this._isNeedUpdate3dTexture = status;
    }

    _on2DPlanClick() {
        if (!this._e3plan3D || this._e3plan3D.isHidden()) return;

        this._on3DPlanClick({view2D: false});
    }

    _initMsgListener(id) {
        this.receiveMessageFromInfoLabelListener = this.receiveMessageFromInfoLabel.bind(this, id);
        window.addEventListener("message", this.receiveMessageFromInfoLabelListener, false);
    }

    receiveMessageFromInfoLabel(idBlock, event) {
        if (event.data) {
            try {
                const {id, data} = JSON.parse(event.data);

                if (id === 'setStyle') {
                    const style = JSON.parse(data);

                    updateInfoIconStyle(style, idBlock);

                    this.viewer._renderHotSpots();
                }
            } catch (e){
                console.error(e)
            }
        }
    }

    _destroyMsgListener() {
        window.removeEventListener("message", this.receiveMessageFromInfoLabelListener, false);
    }

    _createCompanyLogo(imgSrc, companyUrl) {
        const companyLogoLink = document.createElement('a');

        companyLogoLink.classList.add('company-logo');
        companyLogoLink.href = companyUrl || 'javascript:void(0)'; 
        if(companyUrl){
            companyLogoLink.target = '_blank';
        }

        if (imgSrc) {
            const companyLogoImg = document.createElement('img');

            companyLogoImg.src = imgSrc;
            companyLogoLink.appendChild(companyLogoImg);
        } else {
            companyLogoLink.classList.add('hidden');
        }

        return companyLogoLink;
    }
}
